export const frenchFR = {
  firstNameIsInvalid: 'Ce champ est obligatoire. Un maximum de 100 caractères est autorisé.',
  invalidFirstName: 'Prénom non valide',
  invalidLastName: 'Nom de famille non valide',
  lastNameIsInvalid: 'Ce champ est obligatoire. Un maximum de 100 caractères est autorisé.',
  emailIsInvalid: 'Veuillez saisir une adresse électronique valide',
  organisationIsInvalid: 'Veuillez saisir un maximum de 100 caractères',
  countryCodeIsNotSelected: 'Sélectionnez votre pays',
  passwordIsInvalid:
    'Le mot de passe doit comporter entre 12 et 64 caractères et doit contenir au moins une lettre majuscule, une lettre minuscule, un chiffre et un symbole.',
  confirmPasswordInvalid: 'Le mot de passe et le mot de passe de confirmation ne correspondent pas',
  passwordsNoMatchInvalid: 'Les mots de passe ne correspondent pas',
  confirmPasswordEmpty: 'Veuillez confirmer votre mot de passe',
  termsAndConditionsNotAccepted: 'Pour continuer, veuillez lire et accepter les Termes et Conditions',
  suchEmailAlreadyInUse: 'Cet email est déjà enregistré dans le système',
  successfulRegistration: 'Votre compte a été créé avec succès. Vous pouvez maintenant vous connecter',
  somethingWentWrong: "Quelque chose s'est mal passé - veuillez nous contacter (info@keybiodiversityareas.org)",
  passwordHint:
    'Le mot de passe doit comporter de 12 à 64 caractères et doit contenir au moins une lettre majuscule, une lettre minuscule, un chiffre et un symbole.',
  previousPasswordCantBeUsed: 'Le mot de passe précédent ne peut pas être utilisé',
  alreadyUsedOrExpired: 'Le lien de réinitialisation du mot de passe a expiré ou a déjà été utilisé',
  firstNameLabel: 'Prénom',
  email: 'Email',
  password: 'Mot de passe',
  lastNameLabel: 'Nom de famille',
  emailLabel: 'Email',
  organisationLabel: 'Organisation',
  countryLabel: 'Pays',
  countryOfInterestLabel: "Pays d'intérêt",
  interestSelectIsMandatory: 'Veuillez sélectionner le pays qui vous intéresse dans la liste déroulante',
  numberOfKba: 'Nombre de sites',
  triggerSpecies: 'Espèce déclencheuse',
  kbaPartner: 'Partenaire KBA',
  kbaPartnerLabel: 'Partenaire KBA',
  passwordLabel: 'Mot de passe',
  confirmPasswordLabel: 'Confirmez le mot de passe',
  termsAndConditionsText: "J'accepte de",
  categoryDropdown: 'Liste déroulante des catégories',
  allCategories: 'Toutes les catégories',
  createAccountButton: 'Créer un compte',
  firstNamePlaceholder: 'Entrez votre prénom',
  lastNamePlaceholder: 'Entrez votre nom de famille',
  emailPlaceholder: 'Saisissez votre adresse électronique',
  searchPlaceholder: 'Recherche…',
  organisationPlaceholder: 'Organisation',
  passwordPlaceholder: 'Entrez votre mot de passe',
  newPasswordPlaceholder: 'Entrez votre nouveau mot de passe',
  confirmPasswordPlaceholder: 'Confirmez votre mot de passe',
  confirmNewPasswordPlaceholder: 'Confirmez votre nouveau mot de passe',
  enterAndConfirmNewPassword: 'Veuillez entrer et confirmer votre nouveau mot de passe',
  countryPlaceholder: 'Sélectionnez votre pays',
  countryOfInterestPlaceholder: "Sélectionnez votre ou vos principaux pays d'intérêt",
  kbaPartnerPlaceholder: 'Sélectionnez votre affiliation à KBA Partner (le cas échéant)',
  alreadyHaveAnAccount: 'Vous avez déjà un compte?',
  signIn: "S'identifier",
  signUp: "S'inscrire",
  signOut: 'Se déconnecter',
  dontHaveAnAccount: "Vous n'avez pas de compte?",
  changePassword: 'Changer le mot de passe',
  rememberMeCheckbox: 'Se souvenir de moi',
  forgotPassword: 'Mot de passe oublié?',
  pleaseEnterYourCredentials: "Veuillez entrer vos informations d'identification",
  pleaseEnterYourEmail: 'Veuillez saisir votre adresse électronique',
  emailOrPasswordIncorrect: 'Email ou mot de passe invalide',
  resetPassword: 'Réinitialiser le mot de passe',
  rememberYourPassword: 'Mémoriser le mot de passe',
  passwordChangeSuccessful: 'Votre mot de passe a été modifié avec succès',
  assessmentsHint: 'Toutes les évaluations {assessmentNumber}',
  allAssessments: 'Toutes les évaluations {assessmentsNumber}',
  reassessSite: 'Évaluer la biodiversité',
  resetPasswordSuccessful:
    'Si cette inscription existe, vous recevrez un email contenant les instructions pour réinitialiser votre mot de passe dans quelques minutes',
  roleSelectLabel: 'Rôle',
  roleSelectPlaceholder: 'Sélectionnez votre rôle',
  roleSelectIsMandatory: 'Veuillez sélectionner votre rôle dans la liste déroulante',
  pleaseEnterNewPassword: 'Veuillez entrer un nouveau mot de passe',
  propose: 'Proposer une évaluation',
  proposeSite: 'Ajouter un nouveau site',
  editProfile: 'Modifier le profil',
  profile: 'Mon profil',
  accountSettings: 'Paramètres du compte',
  terms: "Conditions d'utilisation",
  privacy: 'Politique de confidentialité',
  dashboard: 'Dashboard',
  sites: 'Sites',
  users: 'Utilisateurs',
  monitoring: 'Surveillance',
  forum: 'Forum',
  activeUsers: 'Utilisateurs actifs',
  noMatchingFilterCriteria: 'Aucun utilisateur ne correspond aux critères de filtrage',
  clearFilters: 'Effacer les filtres',
  moldova: 'Moldova',
  ncg: 'NCG',
  notifications: 'Notifications',
  nothingHereSoFar: 'Rien ici pour l\'instant...',
  proposerName: 'Nom du proposant',
  proposerEmail: 'Email du proposant',
  noSensitiveSitesFound: 'Aucun site sensible trouvé',
  individual: 'Individuel',
  // ecoRegionMapHint: '',
  '/terms-and-use': "Conditions d'utilisation",
  '/users': 'Gestion des utilisateurs',
  '/sites': 'Gestion des sites',
  '/profile': 'Paramètres du profil',
  'registrationPage.pageTitle': 'Inscription',
  showing: 'Affichage',
  secretariat: 'Secrétariat',
  name: 'Nom de famille prénom',
  country: 'Pays',
  countryOfInterest: "Pays d'intérêt",
  role: "Type d'utilisateur",
  userStatus: 'Statut',
  lastLogin: 'Dernière connexion',
  actions: 'Actions',
  date: 'Date',
  time: 'Time',
  usersAndAssessment: 'Users and Assessments',
  siteNameNational: 'Nom du site (National)',
  siteNameInternational: 'Nom du site (International)',
  siteNameEng: 'Nom du site (International)',
  year: 'Année',
  yearOfEstimate: 'Year of estimate',
  proposer: 'Proposant',
  siteStatus: 'Statut',
  noSitesMatchFilteringCriteria: 'Aucun site ne correspond aux critères de filtrage',
  nothingMatchesYourSearch: 'Aucun site ne correspond à votre recherche',
  clearResults: 'Effacer les résultats de la recherche',
  searchUserPlaceholder: "Nom, pays ou type d'utilisateur...",
  search: 'Recherche',
  home: 'Accueil',
  lastName: 'Nom de famille',
  firstName: 'Prénom',
  newPassword: 'Nouveau mot de passe',
  confirmNewPassword: 'Confirmez votre nouveau mot de passe',
  enterCurrentPassword: 'Entrez votre mot de passe actuel',
  enterNewPassword: 'Entrez votre nouveau mot de passe',
  cancel: 'Annuler',
  enterOldPassword: 'Veuillez entrer votre mot de passe',
  changeEmail: "Changer l'email",
  emailConfirmation: "Confirmation de l'email",
  changeEmailConfirmation:
    "Pour terminer le changement de votre adresse email, nous avons envoyé un email à {email}. Cliquez simplement sur le lien dans l'email pour terminer le processus.",
  emailWasChanged: 'Votre nouvelle adresse email a été confirmée',
  emailChanged: "Changement d'adresse email confirmé",
  saveChanges: 'Sauvegarder les modifications',
  deleteProfile: 'Supprimer le profil',
  changeButton: 'Modifier',
  pendingButton: 'En attente',
  goBack: 'Retourner',
  edit: 'Modifier',
  editComment: 'Modifier un commentaire',
  removeComment: 'Supprimer un commentaire?',
  monitorSite: 'Monitor site',
  block: 'Bloquer',
  loginPageDescription: 'Base de données mondiale des zones clés pour la biodiversité',
  loginBottomImageDescription: 'Honduras Spikethumb Frog (Plectrohyla dasypus) © Andrew Snyder / Re:wild',
  addNewCoProposer: 'Ajouter un nouveau co-proposant',
  inviteCoProposers: 'Inviter des co-proposants',
  enterSitename: 'Entrez le nom du site',
  sendInvites: 'Envoyer les invitations',
  pleaseEnterCurrentPassword: 'Veuillez entrer le mot de passe actuel',
  manage: 'Gérer',
  remove: 'Supprimer',
  about: 'À propos',
  nameAndLocation: 'Nom & Localisation',
  nameAndLocationDescription: 'Nom et localisation du site',
  assessment: 'Évaluation',
  invite: 'Inviter',
  manageUsers: 'Gérer les utilisateurs',
  categoryDropdownPlaceholder: 'Catégorie',
  draft: 'Projet',
  submitProposal: 'Proposer une évaluation',
  yourSiteProposalIsInDraft: "Votre évaluation est sous statut Projet et n'a pas été proposée",
  totalUsers: 'Total des utilisateurs',
  siteProposalHasBeenSuccessfully: 'Site proposal has been successfully saved as draft',
  inviteCoProposersModalTitle: 'Inviter les co-proposants',
  enteredEmailAlreadyInUse: 'Cet email est déjà enregistré dans le WDKBA.',
  profileSuccessfullySaved: 'Votre profil a été mis à jour avec succès',
  nominate: 'Nommer',
  nominateSite: 'Nommer une évaluation',
  nominateSiteText: "Etes-vous sûr de vouloir nommer l'évaluation proposée sur le site {siteName}?",
  submitEvaluation: 'Soumettre l’évaluation',
  confirmAssessmentBtn: "Confirmer l'évaluation",
  confirmAssessment: "Confirmer l'évaluation?",
  confirmAssessmentText: 'Etes-vous sûr de vouloir confirmer cette évaluation proposée pour le site {siteName}?',
  approveEditsText:
    "Êtes-vous sûr de vouloir soumettre les changements apportés à {siteName}? Cette action ne peut pas être annulée et vos modifications seront soumises à l'approbation.",
  rejectBtn: 'Rejeter',
  rejected: 'Rejeter',
  delistBtn: 'Retirer de la liste',
  delist: 'Retirer de la liste',
  doesNotQualify: 'Ne Se Qualifie Pas',
  setDoesNotQualify: 'Attribuer le statut Ne Se Qualifie pas',
  delistAssessment: 'Site retiré de la liste?',
  doesNotQualifyModal: "L'évaluation Ne Se Qualifie Pas?",
  doesNotQualifyText:
    'Êtes-vous sûr de vouloir changer le statut du site {siteName} en Ne Se Qualifie Pas? Cette opération ne peut pas être annulée',
  rejectAssessmentBtn: "Rejeter l'évaluation",
  rejectAssessment: "Rejeter l'évaluation?",
  rejectEdits: 'Rejeter les modifications',
  delistAssessmentText: 'Êtes-vous sûr de vouloir supprimer ce site: {siteName}?',
  rejectAssessmentText:
    "Êtes-vous sûr de vouloir rejeter l'évaluation pour {siteName}? L'évaluation sera remise à l'état de projet et le proposant en sera informé. Veuillez vous assurer que les commentaires fournis reflètent les changements nécessaires",
  rejectEditsText:
    "Êtes-vous sûr de vouloir supprimer les modifications apportées à {siteName}? Cette action ne peut pas être annulée et les détails reviendront à ceux approuvés lors de la dernière session d'évaluation ou de modification.",
  nominateAssesment: "Nommer l'évaluation?",
  approve: 'Approuver',
  approveForNomination: 'Approuver la nomination?',
  approveForNominationText: "Êtes-vous sûr de vouloir approuver l'évaluation proposée {siteName}  pour la nomination?",
  manageUser: "Gérer l'utilisateur",
  decline: 'Refuser',
  discardChanges: 'Rejeter les changements?',
  yesCancel: 'Oui, annuler',
  returnToDraft: 'Retourner au projet',
  returnToEditOnly: 'Rejeter les modifications',
  returnDraft: 'Retourner au projet?',
  declineFeedback: 'Commentaires',
  declineAssessment: 'Renvoyer des commentaires?',
  returnFeedbackText:
    "Êtes-vous sûr de vouloir renvoyer la proposition d'évaluation {siteName} en demandant des clarifications et/ou des détails supplémentaires? Veuillez vous assurer que vos raisons sont clairement présentées dans vos commentaires de révision.",
  returnDiscardChangesText:
    "Êtes-vous sûr de vouloir rejeter la réévaluation de {specieName}? Toutes vos modifications seront rejetées et l'ancienne évaluation de cette espèce sera rétablie.",
  categoryName: 'Nom',
  organization: 'Organisation',
  userType: "Type d'utilisateur",
  status: 'Statut',
  viewSite: 'Voir le site',
  viewAll: 'Voir tous',
  pending: 'En attente',
  passwordHasExpired: 'Le mot de passe a expiré',
  currentPassword: 'Mot de passe actuel',
  youHaveToChangePassword:
    "Veuillez changer votre mot de passe - vous ne pourrez pas accéder au système tant que votre mot de passe n'aura pas été changé",
  enterYourPassword: 'Entrez votre mot de passe',
  confirmNewPasswordEmpty: 'Veuillez confirmer votre mot de passe',
  threatenedBiodiversity: 'Biodiversité menacée',
  geographicallyRestrictedBiodiversity: 'Biodiversité géographiquement restreinte',
  ecologicalIntegrity: 'Intégrité écologique',
  irreplaceabilityThroughQuantitiveAnalysis: "Irremplaçabilité par l'analyse quantitative",
  biologicalProcesses: 'Processus biologiques',
  nameContactDetails: 'Nom, détails de contact',
  provideReviewersInfoWhoCanCommentOnYourProposal:
    'Fournissez les détails sur les évaluateurs qui pourraient être en mesure de commenter cette évaluation (leurs noms et coordonnées)',
  restrictedRangeStatus: "Statut de l'aire de répartition restreinte",
  criteria: "Critères de la Liste rouge de l'UICN",
  redListCrit: 'Critères de la Liste Rouge',
  aboutPageTitle: 'A propos de la proposition',
  aboutPageSubTitle: 'Critères KBA évalués',
  ongoingConservationActionsAtSite: 'Actions de conservation en cours sur le site',
  aboutProposalHint:
    'Indiquez les critères que vous appliquez sur le site, même si le site ne répond pas à tous ces critères. Si vous appliquez le critère E, veuillez contacter le secrétariat KBA [hyperlink to info@keybiodiversityareas.org] pour obtenir des détails sur ce qui est requis',
  monitoringPageTitle: 'Surveillance',
  noSpeciesMatchFilteringCriteria: 'Aucun site ne correspond aux critères du filtre',
  nationalSiteName: 'Entrez le nom du site national',
  internationalSiteName: 'Entrez le nom du site international',
  stateProvince: 'État ou province (le cas échéant)',
  stateProvincePlaceholder: "Entrez l'état ou la province",
  siteArea: 'Superficie du site (km²)',
  siteAreaPlaceholder: 'Entrez la superficie du site (km²)',
  latitude: 'Latitude (degrés décimaux)',
  latitudePlaceholder: 'Saisir la latitude du centroïde (en degrés décimaux)',
  longitude: 'Longitude (degrés décimaux)',
  longitudePlaceholder: 'Saisir la longitude du centroïde (en degrés décimaux)',
  coveredByPa: "Couverture par l'Aire Protégée (% calculé)",
  coveredByPaTemplate: "Couverture par l'Aire Protégée (tranche de %)",
  coveredByOECMTemplate: "Couverture par l'OECM ( tranche de %)",
  supersededSitesDesription: 'Details about KBAs that will replaced by others',
  coveredByPaPlaceholder: "La valeur du % de couverture par l'aire protégée.",
  reviewersContactsThatCanComment: 'Examinateurs susceptibles de commenter cette évaluation',
  coveredByPaHint:
    "Pourcentage de couverture par les aires protégées, calculé à partir d'un chevauchement avec les AP définies sur la WDPA {hyperLink}",
  coverageArea: 'Couverture par les OECMs',
  coveredByOECM: 'Couverture par les OECMs (% calculé)',
  coveredByOECMPlaceholder: 'Valeur du % de couverture par les OECMs',
  coveredByOECMHint:
    "% couvert par d'autres mesures efficaces de conservation par zone (OECM), calculé à partir d'un chevauchement avec les OECMs sur la WDPA {hyperLink}",
  habitatsLand: 'Habitats & utilisation des sols',
  habitatsLandDescription: "Habitats et régimes d'utilisation des sols",
  pressures: 'Pressions',
  pressuresDescription: 'Détails sur les pressions et les menaces',
  additionalDetails: 'Détails supplémentaires',
  additionalDetailsDescription: 'Détails supplémentaires concernant le site',
  threats: 'Pressions',
  threatsDescription: 'Description des pressions',
  threatsDescriptionTemplate: 'Description des pressions et des menaces sur le site',
  threatsDescriptionHint:
    'Veuillez fournir une description générale des pressions et des menaces (les pressions qui affectent les éléments de biodiversité importants sur le site) sur le site',
  threatsDescriptionPlaceholder: 'Décrire les pressions et menaces présentes sur le site',
  lowestElevation: 'Altitude la plus basse (m)',
  lowestElevationPlaceholder: "Entrez l'élévation la plus basse en mètres",
  highestElevation: 'Altitude la plus élevée (m)',
  highestElevationPlaceholder: "Entrez l'élévation la plus élevée en mètres",
  uploadFile: 'Upload file',
  uploadFilePlaceholder: 'Upload GIS file',
  systemLargest: 'Système le plus grand',
  system2Largest: 'Système (2ème plus grand)',
  system3Largest: 'Système (3ème plus grand)',
  systemLargestPlaceholder: 'Sélectionnez le système le plus grand',
  system: 'Système',
  secondLargestSystemPlaceholder: 'Sélectionnez le 2ème système le plus grand',
  thirdLargestSystemPlaceholder: 'Sélectionner le 3ème système le plus grand',
  smallestSystemPlaceholder: 'Sélectionner le système le plus petit',
  rationale: 'Justification (identification de la KBA)',
  rationalePlaceholder: 'Expliquez pourquoi ce site est proposé comme KBA.',
  siteDescription: 'Description du site',
  siteDescriptionPlaceholder: 'Entrez une description détaillée du site',
  manageability: 'Possibilité de gestion',
  manageabilityFieldTemplate: 'Comment le site est-il géré ou potentiellement gérable?',
  siteManagedPlaceholder: 'Décrire comment le site est géré?',
  protectedConserved: 'Aires protégées ou conservées',
  protectedConservedDescription: 'Étendue de la couverture du site par des aires protégées ou conservées',
  supersidedSites: 'Sites remplacés',
  supersidedSitesHint:
    'Si vous créez un nouveau site qui remplace un ou plusieurs KBAs existantes, par exemple si vous fusionnez ou divisez des KBAs actuelless, veuillez indiquer le ou les KBA(s) qui sont remplacées - elles seront remplacées lorsque votre site sera confirmé.',
  supersidedSitesPlaceholder: 'Enumérer toutes les KBAs existantes qui sont remplacées par votre nouveau site.',
  delineation: 'Délimitation',
  delineationRationale: 'Veuillez expliquer comment le site a été délimité',
  delineationPlaceholder: 'Veuillez fournir une explication sur la façon dont le site a été délimité',
  siteCoverage: "Couverture par l'Aire Protégée",
  siteCoveragePlaceholder: 'Sélectionnez la tranche de pourcentage',
  protectedArea: 'APs et/ou OECMs couverts',
  protectedAreaPlaceholder: 'Énumérer toutes les APs et/ou les OECM couvertes par la KBA.',
  biodiversityValues: 'Valeurs de la biodiversité',
  biodiversityValuesPlaceholder: 'Indiquer toute autre espèce ou écosystème présent sur le site.',
  siteValues: 'Valeurs du site',
  siteValuesPlaceholder:
    'Énumérer tous les groupes autochtones qui détiennent des droits coutumiers sur le site et décrire les ressources.',
  landUse: 'Utilisation des terres',
  landUsePlaceholder: "Décrire les régimes d'utilisation des terres sur le site",
  habitatDescription: 'Description générale des habitats',
  habitatDescriptionTemplate:
    "Description des habitats, en utilisant si possible la classification des habitats de l'UICN.",
  habitatPlaceholder: 'Décrire les habitats présents',
  habitatHint:
    "Veuillez fournir une description générale des habitats présents - elle sera publiée sur les fiches d'information des KBAs",
  notes: 'Informations complémentaires',
  notesTemplate: 'Tout autre détail concernant le site',
  notesPlaceholder: 'Fournir toute autre information relative au site',
  references: 'Références',
  referencesTemplate: "Références relatives à l'évaluation (et/ou au site)",
  referencesPlaceholder: "Fournir des détails sur les sources d'information (citations, URL, liens vers des rapports)",
  referencesHint:
    "Fournir des détails sur les sources d'information (citations, URL, liens vers des rapports) concernant ce site.",
  siteName: 'Nom du site (international)',
  natureOfOccurence: 'Nature de l\'occurrence',
  sensitiveAtSiteLabel: 'Espèces sensibles',
  sensitiveAtSiteSource: 'Fournir plus de détails sur la sensibilité des espèces sur ce site',
  sensitiveAtSiteSourcePlaceholder: 'Décrire les raisons pour lesquelles cette espèce doit être traitée comme sensible sur ce site',
  sensitiveAtSiteSourceRequired: 'La source est requise lorsque "Sensible sur le site" est activé',
  sensitiveAtSiteHint: 'Cette espèce doit être traitée comme sensible sur ce site',
  ibaRelated: 'Autres conditions liées aux critères IBA',
  ibaRelatedCriteriaHint:
    "Veuillez sélectionner avec soin les déclarations relatives aux critères de l’IBA qui s’appliquent à ce site. Les déclarations pertinentes sont nécessaires pour déclencher les critères IBA respectifs. Veuillez fournir des justifications supplémentaires pour vos sélections dans 'Détails supplémentaires' ci-dessous.",
  siteNameEnglishHint: 'Donner un nom anglophone reconnu pour le site',
  siteNameNationalHint: 'Donner un nom national pour le site',
  countryHint: 'Sélectionner le ou les pays dans la liste et cliquez sur "Appliquer".',
  stateProvinceHint: "Indiquer l'état ou la province du pays où se trouve le site, le cas échéant",
  siteAreaHint:
    "Superficie du site proposé (km²) - si la mesure est effectuée à partir du shapefile, elle doit être projetée à l'aide des Projections Cylindrical Equal Area et du système de référence WGS84.",
  latitudeOfCentroidHint: 'Fournir le centroïde de la latitude - en degrés décimaux avec le système de référence WGS84.',
  longitudeOfCentroidHint:
    'Fournir le centroïde de la longitude - en degrés décimaux avec le système de référence WGS84',
  lowestElevationHint: "Indiquer l'altitude en mètres",
  highestElevationHint: "Indiquez l'altitude en mètres",
  altitudeOfBathymetryHint: '',
  uploadFileHint:
    'You must attach a boundary file for new or revised KBA boundaries. Existing ones with no change do not need a new file.',
  systemHint:
    'Sélectionnez le type de système qui reflète le mieux les éléments déclencheurs auxquels le site répond. Par exemple, si le site ne supporte que des espèces de poissons limitées à ses zones d\'eau douce, sélectionnez "Eau douce". Si le site supporte également un déclencheur pour les libellules qui dépend également d\'habitats terrestres, ajoutez « Terrestre » comme sélection distincte (par exemple, dans la case suivante (2e plus grand, etc.).',
  rationaleHint:
    "Rédigez ici un texte expliquant les raisons pour lesquelles le site est proposé en tant que KBA. Ce texte sera inclus dans les fiches d'information sur le site. Dans le cas d'une redélimitation d'une KBA existante, le texte dans ce champ peut être bref et standardisé, mais il doit être approprié pour la publication sur le WDKBA et dans IBAT. En dehors de \"KBA\", veuillez épeler tous les acronymes utilisés dans les champs inclus dans les fiches de première mention pour chaque site.",
  siteDescriptionHint:
    "Rédigez un compte rendu textuel sur le site - principaux habitats, gamme d'altitude, où il se trouve et tout ce pour quoi il est connu - ce texte apparaîtra sur les fiches d'information trouvées sur le WDKBA. Chaque fiche d'information doit être autonome, même si cela implique la duplication de certains textes sur plusieurs sites. Veuillez éviter les références croisées avec le texte d'autres sites (par exemple, \"voir la fiche d'information pour XXX KBA\"), car ce texte peut être mis à jour à l'avenir et nous ne pouvons pas suivre les références croisées. Si un site est réévalué et qu'il n'y a pas de changement, vous pouvez indiquer que ce texte reste tel quel.",
  siteManagedHint:
    "Rédigez un texte expliquant pourquoi vous pensez que le site est gérable en tant qu'unité unique - ce texte apparaîtra sur les fiches d'information trouvées sur le WDKBA",
  delineationHint:
    "Pour tous les nouveaux sites ou les KBAs existantes dont le polygone proposé est nouveau ou révisé, veuillez fournir une explication de la manière dont le site a été délimité. Cette explication peut être brève et assez standardisée. Si la délimitation du site est alignée avec la frontière nationale ou une aire protégée existante, veuillez fournir une référence pour la source de données spatiales (par exemple, GADM, WDPA) et le nom de l'aire protégée. (Il ne sera pas toujours évident, à partir du nom de la KBA, de savoir si celle-ci est plus petite ou plus grande).",
  siteCoverageHint:
    "Sélectionnez la tranche de pourcentage qui reflète le mieux l'étendue de la couverture du site par l'AP.",
  biodiversityValueHint:
    'Indiquez toute autre espèce ou tout autre écosystème présent sur le site et qui lui confère une valeur supplémentaire.',
  siteValueHint:
    "Indiquez si le site comprend des terres, de l'eau ou d'autres ressources appartenant à des populations autochtones ou soumises à des droits d'usage coutumiers. Veuillez énumérer tous les groupes autochtones qui détiennent des droits coutumiers sur le site.",
  landUseHint: 'Comment les terres sont-elles actuellement gérées sur le site?',
  notesHint: 'Fournir toute autre information relative au site',
  protectedAreaHint:
    "Dresser la liste des aires protégées et/ou des OECMs couvrant le site, ainsi que leur(s) numéro(s) d'identification WDPA, disponible(s) sur Protected Planet.",
  notification: 'Notifications',
  expand: 'Développer',
  collapse: 'Effondrement',
  system2ndLargest: 'Système 2ème plus grand',
  system3rdLargest: 'Système 3ème plus grand',
  systemSmallest: 'Système le plus petit',
  congregatoryGroup: 'Groupe de congrégation',
  ecoRegion: 'Ecorégion',
  searchEcoRegionName: "Chercher le nom de l'écorégion",
  ecoRegionHint:
    "Fournissez les détails de votre évaluation de l'intégrité écologique ici - veuillez fournir votre rapport annexe directement à votre point focal régional {hyperLink}",
  criterionC: 'Intégrité écologique',
  criterionCSubTittle: "Détails de l'évaluation de l'intégrité écologique sur le site",
  irreplaceability: 'Irremplaçabilité',
  irreplaceabilitySubTittle: "Détails de l'irremplaçabilité sur le site",
  irreplaceabilityHint:
    "Veuillez contacter votre point focal régional et le secrétariat KBA directement avec votre documentation sur l'évaluation de l'irremplaçabilité. Une fois l'évaluation approuvée, vous pouvez cocher la case ci-dessous pour indiquer que votre évaluation d'irremplaçabilité a été approuvée et que ce site répond au critère E de la KBA.",
  enterIrreplaceabilityScore: "Entrez le score d'irremplaçabilité",
  irreplaceabilityScore: "Score d'irremplaçabilité",
  irreplaceabilityScoreHint: "Veuillez entrer votre score d'irremplaçabilité",
  enterAssessmentDate: "Entrez l'année de l'évaluation",
  irreplaceabilityAssessmentDateHint: "Veuillez saisir l'année de l'évaluation",
  checkboxIrreplaceability: "Évaluation d'irremplaçabilité approuvée, le site satisfait au critère E",
  irreplaceabilityCheckboxHint:
    "Cochez la case lorsque votre évaluation d'irremplaçabilité a été examinée et approuvée par le RFP et le secrétariat KBA.",
  irreplaceabilityCheckboxLabel: "Evaluation d'irremplaçabilité",
  irreplaceabilityAssessmentDateLabel: "Année d'évaluation",
  ecoRegionSite: 'Nombre de sites',
  enterNumberOfCriterionCSites: 'Combien de sites répondent au critère C pour cette écorégion?',
  assessmentDate: "Année de l'évaluation de l'intégrité écologique",
  assessmentDateEx: "Indiquez l'année de l'évaluation",
  assessmentDateEco: "Année des données sur l'écosystème",
  assessmentDateEcoPlaceholder: "Indiquez l'année des données sur l'écosystème",
  enterEvidenceForLowHumanImpact: "Fournir des preuves d'un faible impact humain",
  enterEvidenceForIntactEcologicalCommunities: "Fournir des preuves de l'intégrité des communautés écologiques",
  criteriaAssessed: 'Critères évalués',
  ecosystemName: "Nom de l'écosystème",
  ecosystemCodeNumber: 'Code number',
  ecosystemCategory: "Catégorie de la liste rouge des écosystèmes de l'UICN",
  ecosystemGlobalExtent: 'Étendue globale (km²)',
  ecosystemExtent: 'Étendue minimale sur le site (km²)',
  ecosystemExtentBest: "Meilleure estimation de l'étendue sur le site (km²)",
  ecosystemExtentMax: 'Étendue maximale sur le site (km²)',
  ecosystemDataTable: 'Écosystèmes',
  ecosystemDataTableSubTitle: 'Écosystèmes déclenchant les critères KBA',
  ecosystemDataTableHint: '',
  otherCriteriaDataTable: 'Autres critères',
  otherCriteriaDataTableDescription: 'Évaluation du critère C ou du critère E sur le site',
  source: 'Source',
  sourceGlobal: 'Source (estimations mondiales)',
  enterEcosystemName: "Donnez un nom à l'écosystème",
  codeNumberEx: " 'E.g 00005",
  selectEcosystemCategory: 'Sélectionnez la catégorie UICN de la liste rouge des écosystèmes',
  enterGlobalExtent: "Indiquez la meilleure estimation de l'étendue mondiale",
  enterSiteMinExtent: "Indiquez l'étendue minimale sur le site (si disponible)",
  enterSiteBestEstimateExtent: "Entrez la meilleure estimation de l'étendue sur le site",
  enterSiteMaxExtent: "Indiquez l'étendue maximale sur le site (si disponible)",
  enterSourceOfEcosystemData: "Fournissez des détails sur la source des données sur l'écosystème",
  ecosystemData: 'Données sur les écosystèmes',
  ecosystemSubTittle: 'Détails sur les écosystèmes évalués sur le site',
  commentsPlaceholder: 'Fournissez vos commentaires ici...',
  newEcosystem: 'Nouvel écosystème',
  collapseGroup: 'Groupe effondré',
  commentsHint:
    'Sélectionnez une nouvelle catégorie ou un fil de discussion existant ci-dessous et fournissez vos commentaires',
  commentsTextArea: 'Zone de texte pour les commentaires',
  comments: 'Commentaires',
  leaveComment: 'Commentaire',
  expandGroup: 'Étendre le groupe',
  ecoRegionSiteHint: "Combien d'autres sites répondent au critère C dans cette écorégion?",
  ecoIntegrityHuman: 'Donnez une description qui justifie que le site a un faible impact humain',
  ecoIntegrityIntact: 'Donnez une description qui justifie que le site possède des communautés écologiques intactes.',
  assessmentDateHint:
    "Année où l'évaluation de l'intégrité écologique a été effectuée. Si vous utilisez des données antérieures à l'année de l'évaluation, indiquez l'année des données.",
  speciesDetailsForm: 'Espèces',
  speciesDetails: 'Espèces',
  speciesAtSite: 'Espèces présentes sur le site',
  speciesDetailsSubTittle: 'Détails des espèces évaluées sur le site',
  searchByScientificName: 'Chercher par nom scientifique...',
  addSpecies: 'Ajouter une espèce',
  ecoIntegrityLowHumanImpact: "Preuve d'un faible impact humain",
  ecoIntegrityEvidenceForIntact: "Preuve de l'existence des communautés écologiques intactes",
  speciesList: "Votre sélection d'espèces",
  speciesAssessment: 'Évaluation des espèces',
  removeSpecies: 'Supprimer des espèces?',
  removeEcosystem: 'Supprimer cette évaluation?',
  yesRemove: 'Oui, Supprimer',
  ecosystemNameHint: "Donner un nom à l'écosystème",
  iucnMemberHint: " 'Please indicate which group(s)?",
  kbaPartnerHint: 'Représentez-vous une ou plusieurs organisations partenaires KBA?',
  ecosystemCodeNumberHint:
    " 'Complete this section if assessing the site against ecosystems criteria A2 or B4. If known put the WDKBA ecosystem code here. Put the ecosystem element at the site on a new row - do not put it on the same row as a species element",
  ecosystemCategoryHint: 'Donner la catégorie de la liste rouge à partir de la liste rouge des écosystèmes',
  ecosystemGlobalExtentHint:
    "Superficie globale de l'écosystème - mesurer en utilisant la projection standard Cylindrical Equal Area et WGS84 (km²)",
  ecosystemExtentHint:
    "Indiquez la superficie minimale de l'écosystème sur le site (en km²) - mesurée à l'aide de la projection standard Cylindrical Equal Area et  WGS84.",
  ecosystemExtentBestHint:
    "Indiquez la meilleure superficie de l'écosystème du site (en km²) - mesurer à l'aide de la projection standard Cylindrical Equal Area et WGS84. Si seules les étendues minimale et maximale sont disponibles, veuillez fournir une estimation de la meilleure comme étant le point médian des étendues minimale et maximale.",
  ecosystemExtentMaxHint:
    "Indiquez la superficie maximale de l'écosystème sur le site (en km²) - mesurez-la à l'aide de la projection Cylindrical equal Area et WGS84.",
  ecosystemAssessmentDateHint:
    "Année où l'évaluation a été faite - si elle est basée sur l'imagerie, il s'agit de l'année de l'image (des détails supplémentaires peuvent être fournis dans le champ Source ci-dessous).",
  acknowledgementText:
    "Géré par BirdLife International au nom du partenariat KBA, et développé avec le soutien généreux de la Garfield Weston Foundation et du Bezos Earth Fund, et également de The Marks Family Charitable Trust, RSPB et d'autres donateurs.",
  ecosystemSourceHint:
    'Fournissez des détails supplémentaires sur la ou les sources de données mondiales et de sites utilisées',
  scientificName: 'Nom scientifique',
  noteLabel: 'Détails supplémentaires (estimations du site)',
  commonName: 'Nom commun',
  taxonomicGroup: 'Groupe taxonomique',
  taxonId: 'ID du taxon',
  taxonid: 'ID du taxon',
  isTaxonomicGroupPrepopulated: 'Le groupe taxonomique est-il pré-peuplé?',
  phylumName: 'Phylum',
  className: 'Classe',
  orderName: 'Ordre',
  familyName: 'Famille',
  category: "Catégorie de la liste rouge de l'UICN",
  rangeRestricted: 'Espèce à aire de répartition restreinte',
  rangeRestrictedHint:
    "Indique si l'espèce a une aire de répartition restreinte, comme décrit pour le critère B2 du standard KBA. Pour certaines espèces, cette catégorie est spécifique à la saison. Les espèces qui n'ont pas fait l'objet d'une évaluation globale de la Liste rouge de l'UICN ne seront pas reconnues comme étant limitées dans leur aire de répartition - veuillez contacter le secrétariat de la KBA {mailTo} si vous avez des questions sur la classification attribuée à cette espèce.",
  possiblyExtinct: 'Probablement éteint',
  determined: 'Déterminé',
  ecoBioRegionRestricted: 'Restreint à une écorégion/biorégion',
  ecoRegionNameMap: 'Ecorégion et carte',
  ecoRegionNameMapPlaceholder: ' ',
  bioRegionNameMap: 'Biorégion et carte',
  bioRegionNameMapPlaceholder: ' ',
  assessmentSystem: "Système d'évaluation",
  evidence: 'Preuve de présence',
  unitsNumber: "Nombre minimal d'unités reproductrices (UR)",
  comprised: 'Définir 10 UR pour cette espèce',
  enterSpeciesCommonName: 'Enter species Common name',
  enterSpeciesTaxonomicGroup: 'Enter species Taxonomic group',
  selectSpeciesRedListCategory: 'Sélectionner la Catégorie la liste rouge des espèces',
  selectEquivalentSystem: 'Sélectionnez le système équivalent',
  selectSpeciesRedListCriteria: 'Select species Red list criteria',
  rangeRestrictionDeterminedBy: 'Range restriction determined by',
  enterEcoRegionName: 'Enter Ecoregion name',
  enterEcoRegionMapUsed: 'Select Ecoregion map used',
  enterBioRegionName: 'Enter Bioregion name',
  enterBioRegionMapUsed: 'Select Bioregion map used',
  speciesRedListHint:
    "Si cette espèce n'a pas fait l'objet d'une évaluation globale de la Liste Rouge de l'UICN et que la catégorie de la Liste Rouge de l'UICN est vide, veuillez sélectionner une catégorie de la Liste Rouge qui correspond le mieux à votre système, et fournir des détails supplémentaires dans le champ \"Système équivalent utilisé\" ci-dessous",
  equivalentSystemHint:
    "Veuillez fournir des détails sur le système d'évaluation équivalent utilisé, et indiquer les équivalences utilisées pour CR, EN et VU.",
  determinedHint: '',
  ecoBioRegionRestrictedHint:
    "Précise si l'espèce est restreinte à une écorégion ou à une biorégion, comme décrit pour les sous-critères B3a et B3b du standard KBA. Les espèces qui n'ont pas fait l'objet d'une évaluation globale de la liste rouge de l'UICN ne seront pas reconnues comme étant limitées à une écorégion ou à une biorégion - veuillez contacter le secrétariat KBA {mailTo} si vous avez des questions sur la classification attribuée à cette espèce.",
  // eslint-disable-next-line no-dupe-keys
  // ecoRegionNameHint: '',
  evidenceHint:
    "Quelles preuves avez-vous qui confirment que l'espèce est présente sur le site? Si vous vous basez sur l'avis d'un expert, indiquez son nom et son adresse électronique (assurez-vous qu'il accepte de communiquer ses coordonnées).",
  yearSpeciesDetailsHint: 'Année la plus récente pour la preuve de présence',
  unitsNumberHint:
    "Veuillez indiquer le nombre minimum d'unités reproductrices présentes sur le site. Il s'agit d'un champ essentiel pour l'évaluation des critères A1 (sauf A1e), B1, B3b et E. Pour plus de détails, voir les lignes directrices KBA.",
  comprisedHint:
    "Ce champ permet d'interpréter le nombre d'URs signalées sur le site. Les stratégies de reproduction varient d'une espèce à l'autre, de sorte que le nombre de 10 UR sera exprimé différemment. Voici quelques exemples de définitions claires de 10 URs: “Espèces qui se lient par paires : 10 paires de mâles et femelles”. “Espèces qui se lient par paires : 10 mâles et 10 femelles”. “10 nids actifs”. “Système d'accouplement de type harem : 1 ou plusieurs mâles et 10 femelles”.  “Cette espèce de mousse est si serrée que l'on peut supposer que 10 UR sont présentes sur 5 m²” ",
  speciesDetailsSourceHint:
    " Veuillez fournir des informations sur la source des données RU fournies - quelles preuves avez-vous que le site contient le nombre minimum d'unités reproductrices que vous avez saisi et que l'espèce est présente, et incluez toutes les sources (par exemple, référence à un livre, un article, un rapport, une URL). Quelle est l'année de l'estimation RU? Si elle est basée sur l'avis d'un expert, indiquez le nom et l'adresse e-mail de l'expert (assurez-vous qu'il est prêt à partager ses coordonnées) et l'année où l'expert a vu les RU.",
  parameterHint:
    "Veuillez examiner les données disponibles sur un site aux niveaux mondial et local pour cette espèce, et décider quel paramètre d'évaluation fournit la meilleure indication de la proportion de la taille de la population mondiale à utiliser (vous trouverez d'autres conseils dans la section 3.1 des lignes directrices KBA). Vous pouvez évaluer cette espèce en utilisant des paramètres d'évaluation supplémentaires (le cas échéant) et/ou en plusieurs saisons.",
  minGlobal: 'Min. mondial',
  bestGlobal: 'Meuilleur mondial',
  bestGlobalEstimate: 'Estimation mondiale (meilleure)',
  maxGlobal: 'Max. mondial',
  newReportTitle: 'Créer un nouveau rapport',
  newReportSubTitle: 'Cliquer sur le bouton du panneau de filtre ci-dessous pour continuer',
  filterPannel: 'Panneau de filtre',
  enterRegionalMin: "Saisir l'estimation régionale minimale",
  enterRegionalBest: 'Saisir la meilleure estimation régionale',
  enterRegionalMax: "Saisir l'estimation régionale maximale",
  regionalMin: 'Régionale (min)',
  regionalBest: 'Régionale (meilleure)',
  regionalMax: 'Régionale (max)',
  regionalEstimate: 'Source (estimations régionales)',
  euPopulation: "Estimation de l'UE",
  nationalPopulation: 'Estimation nationale',
  euEstimate: 'Source (estimation UE)',
  nationalEstimate: 'Source (estimation nationale)',
  enterSpeciesMinGlobalData: "Saisir l'estimation globale minimale",
  enterSpeciesBestGlobalData: 'Saisir la meilleure estimation globale',
  enterSpeciesMaxGlobalData: "Saisir l'estimation globale maximale",
  enterRegionalEstimate: 'Saisir les estimations régionales',
  enterEuPopulation: "Saisir l'estimation de la population de l'UE",
  enterNationalPopulation: "Saisir l'estimation de la population nationale",
  enterEuEstimate: "Saisir l'estimation de l'UE",
  enterNationalEstimate: "Saisir l'estimation nationale",
  enterSpeciesGlobalSourceData: 'Décrivez la source des estimations globales',
  enterNotesOnSpeciesGlobalData: 'Veuillez fournir tout autre détail relatif à ces estimations globales.',
  bestGlobalHint:
    "Si vous n'avez qu'une seule valeur globale, veuillez la saisir dans le champ \"Meilleure\". Si vous n'avez qu'un minimum et un maximum, veuillez indiquer le point médian de ces valeurs dans le champ \"Meilleure\". Les unités doivent correspondre à celles du paramètre d'évaluation sélectionné.",
  maxGlobalHint:
    "Veuillez saisir l'estimation globale maximale (si disponible) basée sur le paramètre d'évaluation sélectionné. Les unités doivent correspondre à celles du paramètre d'évaluation sélectionné.",
  minGlobalHint:
    "Veuillez saisir l'estimation globale minimale (si disponible) basée sur le paramètre d'évaluation sélectionné. Les unités doivent correspondre à celles du paramètre d'évaluation sélectionné.",
  globalDataSourceHint:
    'Si vous fournissez des estimations globales, veuillez fournir une source (y compris un lien si disponible/pertinent) pour ces estimations (par exemple, une référence à un livre, un article, un rapport, une URL).',
  globalDataNoteHint: 'Veuillez fournir tout autre détail pertinent pour ces estimations mondiales.',
  regionalMinHint:
    'Fournir une estimation minimale pour la population régionale, biogéographique ou autre population distincte de cette espèce',
  regionalBestHint:
    'Une meilleure estimation doit être fournie pour cette évaluation. Fournissez la meilleure estimation pour la population régionale, biogéographique ou autre population distincte de cette espèce',
  regionalMaxHint:
    "Fournir l'estimation maximale pour la population régionale, biogéographique ou autre population distincte de cette espèce",
  regionalEstimateHint:
    'Fournir des détails sur la source des estimations fournies pour la population régionale, biogéographique ou autre population distincte',
  euPopulationHint: "Fournissez une estimation de la taille de la population de cette espèce présente dans l'UE.",
  nationalPopulationHint: 'Fournir une estimation de la taille de la population de cette espèce dans le pays.',
  euEstimateHint: "Fournir des détails sur la source de l'estimation fournie par l'UE",
  nationalEstimateHint: "Fournir des détails sur la source de l'estimation nationale fournie",
  minSite: 'Min. Site',
  bestSite: 'Meilleur site',
  maxSite: 'Max. Site',
  derivation: "Détermination de l'estimation",
  enterSpeciesMinSiteData: "Saisir l'estimation du site minimum",
  enterSpeciesBestSiteData: 'Saisir la meilleure estimation du site',
  enterSpeciesMaxSiteData: "Saisir l'estimation maximale du site",
  enterSpeciesSiteSourceData: 'Décrire la (les) source(s) des estimations du site.',
  derivationOfEstimate: "Détermination de l'estimation",
  yearOfSitePopulationEstimates: 'Provide year(s) of estimate(s) given (e.g. 2018-2020)',
  enterNotesOnSpeciesSiteData: 'Veuillez fournir tout autre détail relatif à ces estimations du site.',
  minSiteHint:
    "Veuillez saisir l'estimation minimale du site (si disponible) basée sur le paramètre d'évaluation sélectionné. Les unités doivent correspondre à celles du paramètre d'évaluation sélectionné.",
  bestSiteHint:
    "Si vous n'avez qu'une seule valeur de site, veuillez la saisir dans le champ \"Meilleur\". Si vous n'avez qu'un minimum et un maximum, veuillez entrer le point médian de ceux-ci dans le champ \"Meilleur\". Les unités doivent correspondre à celles du paramètre d'évaluation sélectionné.",
  maxSiteHint:
    "Veuillez saisir l'estimation maximale du site (si elle est disponible) en fonction du paramètre d'évaluation sélectionné. Les unités doivent correspondre à celles du paramètre d'évaluation sélectionné.",
  siteSourceHint:
    "Veuillez fournir une source pour les données sur le site que vous avez saisies (par exemple, une référence à un livre, un article, un rapport, une URL). Si les données sont tirées d'une évaluation de la Liste rouge, veuillez donner le lien vers l'évaluation de la Liste rouge",
  derivationHint: 'Veuillez indiquer comment l\'estimation "Meilleur (site)" a été obtenue',
  siteYearHint: '',
  siteNoteHint:
    "Ajoutez ici toute note supplémentaire relative aux données sur les espèces du site et/ou pour expliquer pourquoi vous proposez l'une des sélections que vous avez faites.",
  occupiedHabitat: 'Occupied habitat',
  globallyMostImportant5OccupiedHabitat: 'Provide information about any available sources supporting your selection',
  triggerLabel: "Raison(s) pour laquelle (lesquelles) l'espèce ne qualifie pas",
  triggerEcosystemLabel: "Raison(s) pour la(les)quelle(s) l'écosystème ne qualifie pas",
  triggerLabelHint:
    "“Si cet élément ne répond plus aux critères KBA, veuillez indiquer pourquoi. Vous devez d'abord décocher la case ‘Qualifie’ et ensuite vous pouvez sélectionner n'importe quelle raison qui s'applique dans le menu déroulant.",
  reasonForSelectionDCriteria: 'Reason for selection D criteria',
  aggregation: 'Aggregations',
  justification: 'Justification (Critère D, agrégations)',
  justificationThatTheSpeciesIsAggregated: 'Justifiez les options que vous avez choisies',
  largestAggregationHint:
    "Ce champ concerne spécifiquement les espèces qui s'agrègent et qui pourraient déclencher le critère D : veuillez décrire comment l'espèce s'agrège (pertinent pour D1) ; justifier que le site abrite une proportion significative de la distribution mondiale de l'espèce pendant les périodes de stress environnemental (pertinent pour D2) ; ou justifier que le site est une source de recrutement (pertinent pour D3). Si vous appliquez D1b, justifiez que le site fait partie des 10 plus grandes agrégations connues pour l'espèce et fournissez des détails sur les 9 autres sites",
  refugium: 'Refugium',
  recruitment: 'Recruitment',
  season: 'Saison',
  specieTriggerPlaceholder: 'If this species no longer qualifies — please select all reason(s)',
  selectMultipleOptions: 'Vous pouvez sélectionner plusieurs options, puis cliquer sur "Appliquer".',
  ecosystemTriggerPlaceholder: 'Improved site information, KBA criteria revision',
  selectSeasonalDistributionAppliedTo: 'Select seasonal distribution applied to',
  aggregationCriteriaHint:
    "Veuillez choisir soigneusement les déclarations relatives à la nature de la présence de l'espèce sur ce site. Ces déclarations permettent de déterminer les critères à remplir - par exemple, vous devrez préciser que l'espèce forme des agrégations (pour répondre au critère D) et/ou qu'elle est présente régulièrement (pour répondre aux critères A ou B)",
  occupiedHabitatHint:
    'Is this site part of the globally most important 5% of occupied habitat for this species AND you want to apply subcriterion B3c? If so, select "Yes". If not, use the default setting. See KBA Guidelines section 2.6. Please also submit information with proposal about all sites known which also meet this 5%',
  sourceHabitatHint:
    "Veuillez fournir une source à la justification que vous avez saisie pour les agrégations (par exemple, une référence à un livre, un document, un rapport, une adresse URL). Si vous vous appuyez sur l'avis d'un expert, indiquez son nom et son adresse électronique (assurez-vous qu'il est est disposé à partager ses contacts)",
  reasonHint: ' ',
  seasonHint:
    "Si vous appliquez l'estimation à une distribution saisonnière particulière (par exemple, reproduction ou non), ou à un point d'arrêt migratoire, veuillez sélectionner la saison correspondante ici.",
  evidenceTheSpeciesIsPresentAtTheSite: "Preuve de la présence de l'élément déclencheur",
  yearForWitchThereIsEvidence: 'Année la plus récente pour la preuve de la présence',
  minNumberOfReproductiveUnitsRuAtSite: "Nombre minimum d'unités reproductrices (URs) sur le site",
  SpeciesCriteriaTriggered: 'Critères KBA',
  userId: 'ID utilisateur',
  assessmentYear: "Année d'évaluation",
  kbaTriggered: 'Critères KBA déclenchés',
  largestSystem: 'Plus grand système sur le site',
  highEcological: 'Écorégion à haute intégrité écologique sur le site',
  sourceReproductiveUnits: 'Source des données sur les URs',
  whatAre10RusComprisedOf: 'Quelles sont les 10 URs pour ce déclencheur?',
  yearPresence: 'Année (présence)',
  sourceOfRuData: 'Source des données sur les URs',
  sourceOfReproductiveUnitDataIncludingYear: 'Fournir des informations sur la source des données sur les URs',
  assessmentParameterApplied: "Paramètre d'évaluation appliqué",
  parameter: "Paramètre d'évaluation",
  finishEditing: "Terminer l'édition",
  cancelReassessment: 'Annuler la réévaluation?',
  globalData: 'Estimations globales',
  siteSpeciesData: 'Estimations du site',
  regNatEstimates: 'Estimations régionales et nationales',
  siteEstimate: 'Estimation du site (meilleure)',
  newParameter: 'Nouveau paramètre',
  aggregations: 'Aggregations',
  pleaseContactTheKBASecretariatForAnyDataConcerns:
    'Veuillez compléter tous les détails de l\'évaluation concernant "{specieName}".',
  speciesDetailSubTittle: "Détails sur l'espèce",
  speciesDetailSubTittleHint:
    "Veuillez sélectionner l'espèce ou contacter le secrétariat de la KBA si votre espèce n'est pas listée {mailTo}",
  ecosystemSubTitle: "Données sur l'écosystème",
  ecosystemSubTitleHint:
    'Remplissez cette section si vous évaluez le site en fonction des critères écosystémiques A2 ou B4.',
  speciesAssessmentSubTittle: 'Details about the species at global and site level',
  speciesAssessmentSubTittleHint: 'Please select parameter',
  totalSites: 'Total des sites',
  mySites: 'Mes sites {mySitesNumber}',
  totalReports: 'Total des rapports',
  organisation: 'Organisation',
  levelOne: 'Niveau un',
  levelTwo: 'Niveau deux',
  levelThree: 'Niveau trois',
  timing: 'Timing',
  selectLevelThreeThreat: 'Sélectionnez une option de niveau trois',
  selectLevelTwoThreat: 'Sélectionnez une option de niveau deux',
  selectLevelOneThreat: 'Sélectionnez une option de niveau un',
  newThreat: 'Ajouter une nouvelle pression',
  levelOneThreatsHint:
    'Sélectionnez une pression (et les niveaux suivants si demandé) et fournissez des détails sur son timing',
  levelTwoThreatsHint:
    'Sélectionnez une pression (et les niveaux suivants si demandé) et fournissez des détails sur son timing',
  levelThreeThreatsHint: 'Sélectionnez une pression et fournissez des détails sur son timing',
  selectTriggerSpeciesSubtitle: 'Sélectionnez les espèces déclencheuses pour ce site',
  selectTriggerEcosystemSubtitle: 'Sélectionnez les écosystèmes déclencheurs pour ce site',
  threatLevelLabel: 'Niveau de la pression',
  threatTimingLabel: 'Moment de la pression',
  threatTimingPlaceholder: 'Sélectionner le moment de cette pression',
  selectThreatsHint:
    "Sélectionnez les pressions exercées sur ce site et la période la plus pertinente pour chacune d'elles. De plus amples détails sur leurs impacts sur les éléments importants de la biodiversité sont disponibles dans la section Suivi des KBA.",
  selectThreatsForThisSite: 'Sélectionnez les pressions pour ce site',
  threatsHint:
    "Sélectionnez les pressions exercées sur ce site et la période la plus pertinente pour chacune d'elles. De plus amples détails sur leurs impacts sur les éléments importants de la biodiversité sont disponibles dans la section Suivi des KBA.",
  selectThreatLevelTiming: 'Sélectionner le moment de cette pression',
  chooseThreats: 'Pressions',
  whatThreatsAreYouAssessingForThisSite: 'Quelles sont les pressions présentes sur ce site?',
  action: 'Actions de conservation',
  whatActionsAreAssessingForThisSite: 'Quelles actions sont en cours ou nécessaires sur ce site?',
  timingThreatsHint: 'Sélectionnez le timing de cette menapressionce',
  threatsAndAction: 'Pressions et actions',
  removeModal: 'Êtes-vous sûr de vouloir supprimer définitivement ce commentaire?',
  removeModalText: 'Êtes-vous sûr de vouloir supprimer définitivement {name} de la liste? Cette action\n',
  optional: 'Optionnel',
  uploadGisFiles: 'Upload Gis files',
  chooseFile: 'Upload file',
  fileSizeIsTooBig: 'La taille du fichier est trop grande',
  taxonGroup: 'Groupe de taxons',
  iucnStatus: 'Catégorie de la liste rouge',
  reproductiveUnits: 'URs (Min)',
  population: '% dans le site',
  kbaCriteria: 'Critères KBA',
  criteriaKba: 'Critères remplis',
  ibaCriterias: 'Critères IBA',
  calculationsSubTittle: 'Critères de déclenchement pour les espèces',
  pleaseCompleteThisField: 'Veuillez compléter ce champ',
  removeThreat: 'Supprimer la pression',
  reviewers: 'Examinateurs',
  review: 'Examiner',
  commentsLabel: 'Commentaires',
  iucnMember: 'IUCN Member',
  iucnMemberLabel: 'IUCN Member',
  iucnMemberPlaceholder: 'List any IUCN Specialist Groups that you are a member of',
  listToComplete: 'Veuillez remplir les champs suivants',
  validation: 'Validation',
  siteDetails: 'Détails du site',
  predefined: 'Prédéfini',
  ecosystems: 'Ecosystèmes',
  ecosystemsAtSite: 'Écosystèmes sur le site',
  ecosystemRedListCat: 'IUCN Red List of Ecosystems category',
  ecosystemGlobalExtentBest: 'Étendue des écosystèmes sur le site (meilleure estimation)',
  ecosystemKbaTriggered: 'Ecosystem KBA criteria triggered',
  speciesGlobal: 'Espèces globales',
  siteDetailsDescription: 'Autres détails sur le site et sa biodiversité',
  manageabilityDelineation: 'Possibilité de gestion et délimitation',
  manageabilityDelineationDescription:
    'Détails supplémentaires sur la possibilité de gestion du site et la délimitation de la limite.',
  fieldNamename: 'Nom du site',
  fieldNamesiteNameNational: 'Nom national du site',
  fieldNamecountry: 'Pays',
  fieldNamesiteArea: 'Superficie du site (km²)',
  fieldNamelatitudeOfMidPoint: 'Latitude (degrés décimaux)',
  fieldNamelongitudeOfMidPoint: 'Longitude (degrés déc.)',
  fieldNamelowestAltitude: 'Altitude la plus basse (m)',
  fieldNamehighestAltitude: 'Altitude la plus élevée',
  minimumDepth: 'Profondeur minimale (m)',
  minimumDepthHint: 'Fournir la profondeur minimale en mètres; les valeurs de profondeur doivent être positives',
  minimumDepthPlaceholder: 'Indiquer la profondeur minimale en mètres',
  maximumDepth: 'Profondeur maximale (m)',
  maximumDepthHint: 'Fournir la profondeur maximale en mètres; les valeurs de profondeur doivent être positives',
  maximumDepthPlaceholder: 'Indiquer la profondeur maximale en mètres',
  fieldNameAltitudeOfBathymetryId: '',
  fieldNameEcoSystemsId: 'Système le plus grand',
  fieldNamerationaleForSiteInformation: 'Justification',
  fieldNamesiteDescription: 'Description du site',
  fieldNamehowIsTheSiteManaged: 'Site géré',
  fieldNamedeliniationRationale: 'Délimitation',
  fieldNameCoverageOfProtectedAreasId: 'Couverture du site',
  '/': 'Page d\'accueil',
  fieldNameEcologicalIntegrityEcoRegionId: 'Écorégion',
  fieldNamenumberOfCriterionSitesInEcoRegion: "Site d'écorégion",
  fieldNameevidenceOfLowHumanImpact: 'Eco integrity - Low Human impact',
  fieldNameevidenceForIntactEcologicalCommunities: 'Eco integrity - ecological communities',
  proposed: 'Proposé',
  inviteReviewers: 'Inviter les examinateurs',
  supersede: 'Remplacer',
  commentBox: 'Commentaires {commentNumber}',
  changeStatus: 'Changer le statut',
  revertToConfirmed: 'Changer en Confirmé',
  changeStatusToConfirmFromSupersede:
    'Êtes-vous sûr de vouloir changer le statut du site {name} de Remplacé à Confirmé?',
  fieldNamedateOfAssesment: "Date d'évaluation",
  unfinishedProposal: 'Des détails supplémentaires sont nécessaires',
  continueEditing: 'Continuer à modifier',
  confirm: 'Confirmer',
  incompleteFields: 'Champs incomplets',
  oecmOverlapPlaceholder: 'Sélectionner la fourchette de pourcentage',
  oecmDropHint: 'Sélectionner la fourchette de pourcentage qui reflète le mieux la couverture par les OECMs',
  siteId: 'ID du site',
  SiteId: 'SiteID',
  autoSave: 'Enregistrement automatique',
  saving: 'Sauvegarde des modifications',
  backToSites: 'Retour aux sites',
  coProposers: 'Co-proposants',
  draftSiteMessage: "Votre évaluation est à l'état de projet et n'a pas été proposée",
  proposedSiteMessage: 'Ce site est maintenant proposé et est prêt à être examiné par le Point Focal Régional (RFP)',
  nominatedSiteMessage: 'Ce site est maintenant Nominé et est prêt à être examiné par le Secrétariat KBA.',
  nominateAssessment: 'Nominer une évaluation?',
  nominated: 'Nominé',
  reviewedByRFP: 'Ce site a été révisé et peut être Nominé par le Proposant',
  feedback: "Retour d'information",
  returnFeedback: 'Retourner les commentaires?',
  confirmed: 'Confirmé',
  rejectSpecies: "Rejeter l'espèce",
  confirmSpecies: "Confirmer l'espèce",
  siteProposal: 'Proposition de site',
  approveSite: "Approuver l'évaluation",
  approveEditOnlySite: 'Approver les modifications',
  reviewEditOnlySite: 'Examiner les Modifications',
  confirmEcosystem: "Confirmer l'écosystème",
  rejectEcosystem: "Rejeter l'écosystème",
  editOnly: 'Modifier Seulement',
  draftSiteStatusHint: 'Le site est en projet',
  proposedSiteStatusHint: 'Le site a été proposé',
  nominatedSiteStatusHint: 'Le site a été proposé',
  reviewedSiteStatusHint: 'Le site a été examiné',
  confirmedSiteStatusHint: 'Le site a été confirmé',
  supersededSiteStatusHint: 'Le site a été supprimé',
  editSiteStatusHint: 'Site en mode édition',
  noSpeciesSelected: 'Aucune espèce sélectionnée',
  noEcosystemsSelected: "Aucun écosystème n'a été évalué",
  reassess: 'Réévaluer',
  ecologicalIntegrityData: "Données sur l'intégrité écologique",
  newTriggers: 'Nouveaux déclencheurs',
  siteReassessment: 'Évaluation',
  continueReassess: 'Poursuivre la réévaluation',
  justificationNoChange: "Détails supplémentaires lorsqu'aucune modification n'est apportée aux estimations",
  existingTriggers: 'Déclencheurs existants',
  nonQualifying: 'Non qualifiant',
  qualifies: 'Qualifie',
  lastTimeReassessed: 'Date de la dernière évaluation',
  qualificationReasonHint:
    "Veuillez fournir des informations supplémentaires concernant la réévaluation de cet élément de biodiversité, ou tapez N/A. Si l'élément déclencheur ne qualifie plus, veuillez utiliser cet espace pour fournir plus de détails si nécessaire. Si vous déduisez que son étendue, sa répartition et/ou son abondance sont inchangées ou améliorées sur la base d'autres preuves, veuillez fournir des détails supplémentaires et, de préférence, inclure une source pour justifier cela.",
  delisted: 'Retiré de la liste',
  details: 'Détails',
  justificationNoChangeEcoSystemPlaceholder:
    "Veuillez fournir une justification si vous ne fournissez pas d'estimations actualisées du site - par ex. si vous supprimez un écosystème de la liste ou si vous déduisez que l'étendue de l'élément déclencheur est inchangée sur la base d'autres preuves.",
  siteCriteria: 'Critères',
  justificationNoChangeSpeciePlaceholder:
    "Veuillez justifier si vous ne fournissez pas d'estimations actualisées du site -par ex. si vous supprimez un écosystème de la liste ou si vous déduisez que la distribution et l'abondance de l'espèce sont inchangées sur la base d'autres preuves.",
  natureOfOccurrence: "Nature de l'occurrence",
  localTermsUpdatedOn: 'Mis à jour le -',
  localTerms: "Conditions d'utilisation",
  dateUpdatedOn: '20 February 2022',
  termsPageTitle: "Termes et Conditions d'utilisation",
  termsPageSubTitle: "La base de données mondiale des zones clés pour la biodiversité Conditions d'utilisation",
  introductionLabel: 'Introduction',
  introductionSubText:
    "La base de données mondiale des zones clés pour la biodiversité (WDKBA) a été développée par BirdLife International au nom du partenariat KBA. Elle fournit un outil pour aider les individus, les organisations et les groupes de coordination nationaux KBA à proposer des sites comme KBA, à les documenter et à les délimiter, et à les réévaluer pour maintenir les informations à jour, afin de soutenir la conservation des sites les plus importants pour la nature dans le monde entier. Il permet la gestion des données sur les KBA aux niveaux national, régional et mondial, y compris les sites identifiés comme zones importantes pour les oiseaux et la biodiversité et par l'Alliance pour une extinction zéro. Il facilite également la fourniture de données sur les sites importants pour la biodiversité aux gouvernements, au secteur privé (via le {linkTo}) et aux autres parties prenantes, afin de promouvoir leur protection, leur conservation et leur sauvegarde.",
  tableOfContents: 'Table des matières',
  generalLabel: '1. Généralités',
  generalSubText1:
    'Les conditions générales (ci-après dénommées "Conditions") décrites ci-dessous concernent les données saisies dans la base de données mondiale des zones clés pour la biodiversité (WDKBA) par les utilisateurs, notamment',
  generalBullet1:
    'Toutes les données tabulaires, numériques, textuelles ou spatiales (et les attributs associés) relatives aux KBAs.',
  generalBullet2: 'Les données saisies pour évaluer un nouveau site ou pour réévaluer une KBA existante',
  generalBullet3:
    "Les données relatives à l'importance de la biodiversité d'un site, aux attributs physiques ou sociopolitiques d'un site, ou dans le cadre d'une évaluation de suivi d'un site.",
  generalBullet4: 'Données relatives à des évaluations provisoires, proposées, nominées ou confirmées.',
  generalBullet5:
    'Données saisies directement sur le portail Web du WDKBA, via toute fonction de téléchargement par lots ou via tout outil associé (par exemple, pour soumettre ou modifier des données spatiales ou autres sur les limites du site).',
  generalBullet6:
    'Les données sur les KBA existants qui ont été importées dans le WDKBA au moment de son lancement, ainsi que toute donnée saisie ou modifiée ultérieurement',
  generalSubText2:
    "Les conditions prennent effet à partir du moment où vous acceptez ces Termes et Conditions. Les présentes Conditions peuvent être modifiées de temps à autre. Par conséquent, veuillez revoir les Conditions lorsque vous en êtes averti, car toute utilisation de votre part après de telles modifications ou ajouts sera régie par ces Conditions telles que modifiées. Les présentes conditions prévalent sur toute autre restriction imposée aux données que vous saisissez dans le WDKBA. En acceptant les présentes conditions, vous acceptez également de suivre les procédures décrites dans le {linkTo2}. Toutes les données téléchargées à partir du WDKBA sont soumises aux {linkTo}, qui, entre autres restrictions, n'autorisent pas le transfert, la redistribution ou l'utilisation commerciale.",
  intelectualLabel: '2. Propriété intellectuelle et droit de propriété',
  intelectualSubText1:
    "Vous confirmez que vous avez le droit de soumettre toute donnée saisie dans le WDKBA et que, ce faisant, vous n'enfreignez pas les droits d'un tiers. Les utilisateurs et/ou leurs institutions (et les concédants de licence, le cas échéant) conservent la propriété intellectuelle de toutes les données qu'ils introduisent dans le WDKBA et accordent à {linkTo}, en tant que gestionnaire du WDKBA pour le compte du Key Biodiversity Areas (KBA) Partnership, une licence perpétuelle, mondiale et non transférable (avec le droit d'accorder une sous-licence) pour utiliser ces données (dans leur format original, en tout ou en partie, seules ou combinées avec d'autres données), sous réserve de la clause 5 sur les données sensibles, sans demander d'autorisation préalable, à des fins de conservation, y compris",
  intelectualBullet1: 'Réaffichage sur le site web de la KBA {linkTo}',
  intelectualBullet2:
    "Fourniture à d'autres sites Web publics et plateformes en ligne, y compris ceux des partenaires individuels de KBA",
  intelectualBullet3:
    "Fourniture à des tiers à des fins de conservation, de recherche, d'éducation et à d'autres fins non commerciales",
  intelectualBullet4:
    'Utilisation dans le cadre de la recherche, de la communication, du plaidoyer et des applications politiques.',
  intelectualBullet5:
    "Octroi de licences pour une utilisation commerciale par le biais du  {linkTo} (IBAT), soit en rendant les données disponibles directement sur IBAT, soit par l'intermédiaire de tiers, les revenus générés étant utilisés pour soutenir l'identification, la gestion des données ou la conservation des KBA. Aux fins des présentes conditions, on entend par \"utilisation commerciale\" a) toute utilisation par, au nom de, ou pour informer ou aider les activités d'une entité commerciale (une entité qui opère dans un but lucratif) ou b) toute utilisation par un individu ou une entité sans but lucratif dans le but de générer des revenus.",
  intelectualSubText2:
    "Ces objectifs peuvent être atteints par la diffusion de ces données par tout moyen, notamment sur des sites web, des applications mobiles, par le biais de services web, de fichiers KML, de protocoles de transfert de fichiers, de courriers électroniques, de médias ou d'appareils électroniques, de publications et de médias sociaux, etc. Lorsque les données KBA sont présentées sur le site web KBA, les utilisateurs du WDKBA qui sont les proposants ou les co-proposants de chaque site seront reconnus comme tels sur les fiches KBA correspondantes, afin de reconnaître leurs contributions. Ces remerciements seront appliqués à partir de 2022",
  importantBirdLabel: '3. Données sur les Zones Importantes pour les Oiseaux et la Biodiversité',
  importantBirdSubText:
    "Les utilisateurs du WDKBA représentant les partenaires de BirdLife accordent également à BirdLife International une licence non transférable pour utiliser les données sur les sites déclenchés par les oiseaux (\"Important Bird and Biodiversity Areas ; IBAs\"), dans leur format d'origine, en totalité ou en partie, seules ou combinées avec d'autres données, sans demander d'autorisation préalable, à des fins de conservation, y compris toutes celles énumérées dans la clause 3, ainsi que la publication sur la zone de données du site Web de BirdLife. Cette licence s'applique aux données sur les ZICO existantes importées dans le WDKBA au moment de son lancement (conformément à la clause (a) sous Partage d'informations et de données dans les Procédures opérationnelles de BirdLife), et à toutes les données sur les sites déclenchés par les oiseaux entrées ou modifiées ultérieurement. Cette licence restera valable même si l'institution quitte ou est exclue du partenariat BirdLife.",
  sensitiveDataLabel: '4. Données sensibles',
  sensitiveDataSubText:
    "Toutes les évaluations d'éléments de biodiversité marquées par les utilisateurs comme sensibles à l'aide du champ correspondant dans la base de données seront traitées comme indiqué dans le {linkTo1}, et ne seront pas publiées sur le {linkTo2}",
  privacyLabel: '5. Confidentialité',
  privacySubText:
    "En tant que gestionnaire du WDKBA, BirdLife International s'engage à protéger vos informations personnelles et votre vie privée. BirdLife International recueillera et traitera vos données personnelles lors de votre utilisation du WDKBA conformément à sa {lien vers}. Il est important que vous lisiez cette politique afin de savoir comment et pourquoi nous utilisons vos données. La présente politique de confidentialité complète d'autres avis et politiques de confidentialité et n'est pas destinée à les remplacer. Notez que l'enregistrement en tant qu'utilisateur dans le WDKBA permet (a) à d'autres utilisateurs de vous inviter à contribuer à la réévaluation de tout élément de biodiversité sur un site pour lequel vous étiez le proposant, (b) à d'autres utilisateurs de vous inviter en tant que co-proposant d'un site, et (c) aux points focaux régionaux ou au secrétariat du KBA de vous inviter en tant qu'examinateur d'une proposition de site. Ces invitations peuvent être envoyées par le biais de notifications dans le WDKBA lui-même, et par courrier électronique à l'adresse que vous avez fournie lors de votre inscription.",
  disclaimerLabel: '6. Avertissement sur les frontières et les limites nationales',
  disclaimerSubText:
    "La désignation d'entités géographiques dans le WDKBA et les outils associés n'implique pas l'expression ou la représentation d'une quelconque opinion par les partenaires du KBA concernant le statut juridique d'un pays, d'un territoire ou d'une zone, ou concernant la délimitation de ses frontières ou limites.",
  disclaimerOfWarrantyLabel: '7. Exclusion de garantie Limitations de responsabilité',
  disclaimerOfWarrantySubText:
    "Ni BirdLife International, ni les autres partenaires du KBA, ni leurs sociétés affiliées, ni aucun de leurs employés, agents, fournisseurs de contenu tiers ou concédants de licence respectifs ne garantissent que l'accès au KBA et son utilisation seront exempts d'interruptions ou d'erreurs, ni que les données téléchargées ou exportées à partir de celui-ci sont exemptes de virus, de vers informatiques ou d'autres éléments nuisibles ; aucune garantie n'est donnée quant aux résultats pouvant être obtenus par l'utilisation du KBA, ni quant à l'exactitude, la fiabilité ou le contenu de toute information extraite de celui-ci. Les données téléchargées à partir du WDKBA sont fournies sans aucune garantie d'aucune sorte, expresse ou implicite, y compris, mais sans s'y limiter, les garanties de titre ou d'adéquation à un usage particulier. Dans toute la mesure permise par la loi, BirdLife International ou d'autres partenaires du KBA ne peuvent en aucun cas être tenus responsables de tout dommage indirect, accessoire ou consécutif découlant de l'utilisation ou de l'incapacité d'utiliser les données du KBA ou du WDKBA ou résultant d'erreurs, d'omissions, d'interruptions, d'omissions, d'interruptions, de suppressions, d'erreurs ou de défauts dans les données KBA, ou de retards dans le fonctionnement, la transmission ou le défaut d'exécution du WDKBA, même si BirdLife International ou d'autres partenaires KBA ont été préalablement informés de la possibilité de tels dommages, ou de toute autre réclamation de votre part ou de celle de toute autre personne",
  indemnificationLabel: '8. Indemnisation',
  indemnificationSubText:
    "Vous acceptez de défendre, d'indemniser et de dégager BirdLife International et les autres partenaires de KBA, ainsi que leurs sociétés affiliées, de tous les dommages, responsabilités, coûts et dépenses, y compris les honoraires d'avocat, liés à toute violation des présentes conditions par vous-même ou par tout utilisateur autorisé de votre compte",
  terminationLabel: '9. Résiliation',
  terminationSubText:
    "BirdLife International, au nom du partenariat KBA, peut suspendre ou mettre fin à votre utilisation du WDKBA à tout moment, avec effet immédiat, avec ou sans préavis, si nous jugeons que votre utilisation du WDKBA compromet sa sécurité ou son intégrité, ou est incompatible avec les objectifs du {linkTo}. Ceci met automatiquement fin à votre licence d'utilisation de toute donnée KBA téléchargée à partir du WDKBA.",
  changeManagementLabel: '10. Changement dans la gestion du WDKBA',
  changeManagementSubText:
    "Si BirdLife International quitte le partenariat KBA et que la gestion du WDKBA est reprise par un autre partenaire KBA, les autorisations accordées ici seront automatiquement transférées à ce partenaire KBA, à l'exception de celles de la clause 3 qui resteront acquises à BirdLife International.",
  governingLawLabel: '11. Litiges relatifs au droit applicable',
  governingLawSubText:
    'Les présentes Conditions et toutes les obligations non contractuelles ou autres découlant de celles-ci ou en rapport avec celles-ci sont régies par le droit Anglais. Tout litige découlant des présentes conditions ou lié de quelque manière que ce soit à celles-ci sera soumis à la juridiction des tribunaux Anglais',
  miscellaneousLabel: '12. Divers',
  miscellaneousSubText:
    "Les dispositions des présentes conditions s'appliquent au bénéfice de BirdLife International et des autres partenaires KBA et de leurs fournisseurs de contenu et concédants de licence tiers. Aucune renonciation par l'une des parties aux présentes à l'une quelconque des dispositions des présentes ou à une violation ou autre manquement aux présentes ne sera considérée comme une renonciation à toute violation ou tout manquement antérieur ou ultérieur",
  contactLabel: '13. Informations de contact',
  contactSubText:
    "Si vous avez des questions sur l'une des présentes conditions ou sur la manière dont elles peuvent s'appliquer à l'utilisation que vous comptez faire du WDKBA et des données KBA qu'il contient, veuillez contacter {mailTo}",
  minYearPlaceholder: "Année la plus ancienne de l'ensemble de données",
  earliestYear: 'Année la plus ancienne (estimation du site)',
  minYear: 'Année (min)',
  minYearTooltip:
    "Veuillez indiquer l'année la plus ancienne de l'ensemble de données pour cette espèce. Si l'évaluation est basée sur des paramètres de surface, veuillez indiquer l'année de l'ensemble de données utilisé pour calculer le pourcentage de couverture.",
  maxYear: 'Année (max)',
  maxYearTooltip:
    "Veuillez indiquer la dernière année de l'ensemble de données pour cette espèce. Si l'évaluation est basée sur des paramètres de zone, veuillez indiquer l'année de l'ensemble de données utilisé pour calculer le pourcentage de couverture.",
  maxYearPlaceholder: 'Dernière année du jeu de données',
  dismiss: 'Rejeter',
  cookies: 'Cookies',
  acceptCookies: 'Accepter les cookies',
  cookiesBody:
    'En cliquant sur le bouton Accepter les cookies,\n' +
    "vous comprenez et consentez à l'utilisation de cookies conformément à notre {hyperLink}",
  deleteDraft: 'Supprimer le projet?',
  deleteEditSiteOnly: 'Supprimer Modifier Seulement le Site ?',
  siteForDeletingBody:
    'Êtes-vous sûr de vouloir supprimer définitivement\n' +
    "le projet d'évaluation de {siteName}? Cette action ne peut être annulée.",
  editSiteForDeletingBody:
    'Êtes-vous sûr de vouloir supprimer les modifications apportées à {siteName}? Cette action ne peut pas être annulée et les détails reviendront à ceux approuvés lors de la dernière évaluation.',
  yesDelete: 'Oui, Supprimer',
  deleteDraftBtn: 'Supprimer le projet',
  cookieSettings: 'Paramètres du cookie',
  assess: 'Évaluer',
  reports: 'Mes rapports',
  download: 'Télécharger',
  view: 'Visualiser',
  sensitiveSpecies: 'Approbation de sites sensibles',
  sensitiveSpeciesVisibilityStatus: 'Statut de visibilité',
  sensitiveSpeciesStatusPending: 'En attente',
  sensitiveSpeciesStatusApproved: 'Approuvé',
  sensitiveSpeciesStatusRejected: 'Rejeté',
  sensitiveSpeciesRevoke: 'Rejeter',
  sensitiveSpeciesRejectAction: 'Rejeter',
  sensitiveSpeciesAlreadyApproved: 'Ce site a déjà été approuvé.',
  sensitiveSpeciesAlreadyRejected: 'Ce site a déjà été rejeté.',
  '/reports': 'Rapports de mes sites',
  createReport: 'Créer un rapport de mes sites,',
  filters: 'Filtres',
  downloadAll: 'Télécharger tout',
  overview: 'Aperçu',
  filtersPanel: 'Panneau de filtre',
  filtersApplied: 'Filtres appliqués',
  runReport: 'Exécuter le rapport',
  siteFilters: 'Filtres de site',
  speciesFilters: "Filtres d'espèces",
  ecosystemFilters: "Filtres d'écosystème",
  ecologicalFilters: "Filtres d'intégrité écologique",
  otherFilters: 'Autres filtres',
  region: 'Région',
  kbaClassification: 'Classification KBA',
  globalKbaCriteria: 'Critères mondiaux KBA',
  assessmentDateFilter: "Année d'évaluation",
  selectRegion: 'Sélectionner une région',
  selectCountry: 'Sélectionnez votre pays',
  selectSystem: 'Sélectionner le système',
  selectThreat: 'Sélectionner la pression',
  selectAssessmentStatus: "Sélectionner le statut d'évaluation",
  selectKbaStatus: 'Sélectionner le statut KBA',
  kbaStatus: 'Statut de la KBA',
  selectKbaClassification: 'Sélectionner la classification KBA',
  selectGlobalKbaCriteria: 'Sélectionner les critères mondiaux KBA',
  selectAssessmentDate: "Sélectionner l'année d'évaluation",
  selectEcosystem: "Sélectionner l'écosystème",
  selectEcosystemRedListCategory: "Sélectionnez la catégorie Liste rouge de l'écosystème",
  selectEcoregion: "Sélectionner l'écorégion",
  ecoregion: 'Ecorégion',
  ecoregionBioregionRestricted: 'Écorégion / biorégion restreinte',
  ecosystemRedListCategory: "Catégorie Liste rouge de l'écosystème",
  species: 'Espèces',
  backToReports: 'Retour aux rapports',
  factsheet: "Fiche d'information",
  id: 'Id',
  RedListCategoryCode: "Catégorie Liste Rouge de l'UICN",
  specieName: 'Nom commun',
  IUCNRedListCriteria: "Critères de la liste rouge de l'UICN",
  equivalentSystemIfNotRedList: "Système équivalent si ce n'est pas la liste rouge de l'UICN",
  EcoBioRegionRestrictedId: 'Eco Bio-Region restricted Id',
  paramId: 'Parameter Id',
  SiteAssessmentParameterTypeId: "Paramètre d'évaluation",
  earliestDataSetYear: 'Earliest year (site estimate)',
  minReproductiveUnits: 'Reproductive units (Min.)',
  ruSource: 'Reproductive units (Source)',
  kbaCriterias: 'Species KBA criteria triggered',
  publishedYear: 'Published year',
  isRedListCategoryCodePrepopulated: 'Is IUCN Red List category prepopulated ?',
  ecoregions: 'Ecoregions',
  bioregions: 'Bioregions',
  SeasonalDistributionId: 'Season Id',
  sourceGlobalData: 'Global estimate (source)',
  latestDataSetYear: 'Latest data set year',
  DerivationOfEstimateId: 'Derivation of site estimate Id',
  sourceOfData: 'Site estimate (source)',
  ruCompromisedOf: 'Reproductive units (what are 10 comprised of?)',
  createdAt: 'Site created at',
  speciesPresenceEvidence: 'Evidence that species is present at site',
  yearPresenceEvidence: 'Most recent yr for evidence of presence',
  regularlyHeld: 'Regularly held',
  regularlyOccurring: 'Regularly occurring',
  regularlyHeldRestricted: 'Regularly held restricted',
  globallyMostImportant: 'Globally most important',
  aggregationPredictability: 'Aggregation predictability',
  aggregationsAsCriteria: 'Aggregations as criteria',
  recruitmentSource: 'Recruitment source',
  treatment: 'Current taxonomic treatment',
  siteAreaCalculated: 'Superficie du site (km²)',
  latitudeOfMidPointCalculated: 'Latitude (degrés déc.)',
  longitudeOfMidPointCalculated: 'Longitude (degrés déc.)',
  lowestAltitude: '',
  highestAltitude: '',
  thisSpecieAlreadyAddedToSiteAssesment: "Cette espèce est déjà inscrite dans l'évaluation",
  calculatedProtectedArea: 'Site % area of covered by protected areas/OECMs (calculated)',
  minDepth: '',
  maxDepth: '',
  SiteStatusId: 'Id du statut KBA',
  SiteDetailsCountryId: 'Site details country id',
  siteCode: 'Code du site',
  rationaleForSiteInformation: 'Justification de la proposition de site',
  howIsTheSiteManaged: 'Gestion du site',
  deliniationRationale: 'Justification de la désignation du site',
  CoverageOfProtectedAreasId: 'Site % area of covered by protected areas (user estimated)',
  additionalBiodiversityValues: 'Indiquez toute autre espèce ou écosystème présent sur le site',
  indigenousGroups: 'Site ownership by indigenous peoples',
  indigenousGroupsTemplate: 'Site values (indigenous people or customary use rights)',
  landUseRegimesAtSite: 'Utilisation des terres du site',
  landUseRegimesAtSiteTemplate: "Régimes d'utilisation des terres sur le site",
  EcoSystemsId: "Système le plus large de l'Id site",
  EcoSystems2LargestId: 'Deuxième système le plus large du site',
  EcoSystems3LargestId: '3ème plus grand système du site',
  EcoSystemsSmallestId: 'Plus petit système du site',
  EcologicalIntegrityEcoRegionId: 'Écorégion à haute intégrité écologique sur le site',
  evidenceOfLowHumanImpact: "Preuve d'un faible impact humain sur le site",
  evidenceForIntactEcologicalCommunities: "Preuve de l'existence de communautés écologiques intactes sur le site",
  dateOfAssesment: "Date d'évaluation de l'intégrité écologique du site",
  ecoregionEcologicalIntegrity: "Intégrité écologique de l'écorégion",
  secondLargestSystem: 'Deuxième plus grand système',
  thirdLargestSystem: 'Troisième plus grand système',
  smallestSystem: 'Système le plus petit',
  historyId: 'Id historique',
  importData: 'Importer des données',
  browseFile: 'Parcourir le fichier',
  orDragACSVFileHere: 'ou faites glisser un fichier CSV ici (30MB max.)',
  downloadCSVTemplates: 'Télécharger les modèles CSV',
  validateFile: 'Validation de votre fichier...',
  fileValidated: 'Fichier validé avec succès',
  important: 'Important',
  downloadCSVFile: 'Télécharger le fichier des erreurs',
  uploadNewFile: 'Télécharger le fichier mis à jour',
  importModalErrorBannerText:
    "Veuillez télécharger le fichier d'erreurs (lien ci-dessous) qui indique les enregistrements spécifiques (numéro de ligne) et les champs qui doivent être traités. Ici, il y a {count} d'erreurs listées. Modifiez ces champs dans le fichier CSV original et téléchargez-le à nouveau.",
  validationFailed: 'Échec de la validation',
  importingYourData: 'Importation de vos données',
  siteAttributes: 'Attributs du site',
  assessmentSpecies: 'Espèces évaluées',
  threatsAndActions: 'Pressions et actions',
  dropFileToAttach: 'Déposer le fichier à uploader',
  removeFileText:
    'Êtes-vous sûr de vouloir supprimer définitivement\n' +
    ' le  {title} des fichiers uploadés? Cette action ne peut pas être annulée',
  'removeFile?': 'Supprimer le fichier?',
  noResultsToShow: 'Aucun résultat à afficher',
  threatsId: 'Pressions ID',
  rejectedTriggers: 'Déclencheurs rejetés',
  approvedTriggers: 'Déclencheurs approuvés',
  permanentTooltipDefaultBody: "Veuillez noter que l'importation du fichier CSV ajoutera les données existantes du site",
  permanentTooltipDefaultTitle: 'Important',
  reportLoadingScreenTitle: 'Création du rapport',
  runningReport: "Votre rapport est en cours d'exécution, veuillez patienter...",
  buildingReport: 'Veuillez patienter, ceci peut prendre un certain temps...',
  permanentTooltipDefaultFooter: 'Ok, Compris',
  congregationSpeciesGroup: "Groupe d'espèces",
  congregationSpeciesGroupPlaceholder: 'Aucun groupe sélectionné',
  minCongregationEstimate: 'Estimation minimale (individus matures)',
  minCongregationPlaceholder: "Entrez l'estimation minimale chez les individus matures",
  bestCongregationEstimate: 'Meilleure estimation (individus matures)',
  bestCongregationPlaceholder: 'Indiquez la meilleure estimation chez les individus matures',
  maxCongregationEstimate: 'Estimation maximale (individus matures)',
  maxCongregationPlaceholder: "Indiquez l'estimation maximale chez les individus matures",
  detailsCongregationLabel: 'Détails supplémentaires',
  detailsCongregationPlaceholder:
    'Veuillez fournir des détails supplémentaires, tels que des informations sur la source des estimations.',
  congregationTitle: 'Congrégations multi-espèces',
  congregationSubTitle: "Veuillez sélectionner un groupe d'espèces et fournissez les détails de l'évaluation",
  addNewCongregation: 'Nouvelle congrégation',
  newCongregationTitle: 'Nouvelle congrégation',
  removeCongregations: 'Supprimer une congrégation?',
  removeCongregationModalBody:
    'Êtes-vous sûr de vouloir supprimer définitivement {name} de la liste? Cette action ne peut pas être\n' + ' annulée',
  fileImportError: 'La structure du fichier ou les noms des champs ne doivent pas être modifiés',
  congregationTable: 'Congrégations',
  congregationDataTableSubTitle: 'Site déclenché par les critères de congrégation IBA',
  noCongregationSelected: 'Aucune congrégation sélectionnée',
  speciesGroup: "Groupe d'espèces",
  estimateBest: 'Estimation (meilleure)',
  ibaCriteria: 'Critères IBA',
  biodiversityKnowledgeHolders: 'Détenteurs de connaissances sur la biodiversité',
  uploadSiteFiles: 'Télécharger le document justificatif',
  uploadSiteFilesHint:
    "Veuillez télécharger tout document justificatif (fichiers Word, PDF, fichiers Excel, données spatiales, etc.) qui appuie cette évaluation (détails sur le site ou l'élément déclencheur).Vous devez indiquer clairement, en nommant le(s) fichier(s), à quelle partie de l'évaluation il(s) se rapporte(nt) (et/ou inclure un fichier readme/lisez-moi s'il y en a plusieurs).La taille totale des fichiers téléchargés ne doit pas dépasser 50 Mo.",
  biodiversityKnowledgeHoldersPlaceholder:
    'Décrivez vos consultations avec les détenteurs de connaissances en matière de biodiversité et dressez la liste de ces derniers dans le cadre de cette évaluation',
  biodiversityKnowledgeHoldersHint:
    "Décrivez vos consultations avec les détenteurs de connaissances en matière de biodiversité et dressez la liste de ceux qui sont concernés par cette évaluation; il peut s'agir de scientifiques internationaux/locaux, de gouvernements et d'autres détenteurs de connaissances sur biodiversité",
  previousProposers: 'Proposants précédents',
  previousProposersPlaceholder:
    "Veuillez décrire vos consultations avec tous les précédents proposants d'évaluations relatives à cette KBA",
  previousProposersHint:
    "Si vous modifiez les détails du site ou les limites d'une KBA existante, veuillez décrire vos consultations avec les précédents proposants d'évaluations relatives à cette KBA, en documentant en particulier les discussions relatives aux modifications des limites et aux résolutions. Si aucune modification n'est apportée, veuillez indiquer \"Aucune consultation car cette proposition ne modifie pas une KBA existante\"",
  government: 'Gouvernement',
  governmentPlaceholder: 'Décrivez votre consultation avec les autorités gouvernementales compétentes',
  governmentHint:
    " Votre gouvernement local et/ou national doit être au courant de vos évaluations des KBA - décrivez votre consultation avec les autorités gouvernementales compétentes, y compris celles associées aux consultations sur les connaissances en matière de biodiversité ci-dessus. Cela peut être une présentation des KBA lors d'un atelier auquel le gouvernement était présent, ou de réunions spécifiques sur le site",
  customaryLegalRightsHolders: 'Titulaires de droits coutumiers ou légaux',
  customaryLegalRightsHoldersPlaceholder:
    'Décrire toute consultation avec les détenteurs de droits coutumiers ou légaux',
  customaryLegalRightsHoldersHint: 'Décrire toute consultation avec les détenteurs de droits coutumiers ou légaux',
  contributors: 'Contributeurs',
  contributorsPlaceholder:
    'Veuillez énumérer  les noms des personnes/ leur institution, dans un format qui peut être rendu public .',
  contributorsHint:
    "Veuillez énumérer les noms des personnes et, le cas échéant, leur institution, dans un format qui peut être rendu public sur le site Web de la KBA; les contributeurs doivent être informés dès le départ que leurs contributions seront ainsi reconnues. N'incluez pas de détails supplémentaires tels que les coordonnées, pour des raisons de confidentialité des données.",
  searchSitePlaceholder: 'Rechercher un site par nom ou par identifiant de site',
  chooseHabitats: 'Habitats',
  whatHabitatsAreYouAssessingForThisSite: 'Quels habitats sont présents ?',
  habitatsHint:
    "Veuillez sélectionner dans le menu déroulant suivant, les habitats présents sur ce site et indiquer le pourcentage que l'habitat occupe sur le site.",
  levelOneHabitatsHint: "Sélectionner l'habitat de niveau élevé",
  selectLevelOneHabitat: 'Choisir parmi les options de niveau un ',
  selectLevelTwoHabitat: 'Choisir parmi les options de niveau deux',
  removeHabitat: 'Retirer l\'habitat',
  habitatsPercentage: '% sur le site',
  habitatsPercentagePlaceholder: "Saisir le % que l'habitat occupe sur le site",
  habitatsPercentageHint: "Pourcentage de l'habaitat sur le site",
  newHabitat: 'Nouvel Habitat',
  map: 'Carte',
  loadingMap: 'Chargement de la carte...',
  siteBoundaryLayerTitle: 'Limite du Site',
  allKBAsLayerTitle: 'Toutes les KBAs actuelles',
  wdpaLayerTitle: 'Sites WDPA',
  wdpaPointLayerTitle: 'Points WDPA',
  wdpaPolygonLayerTitle: 'Polygones WDPA',
  siteBoundary: 'Limite du Site',
  siteBoundaryDescription: 'Section sur la limite du site. Brève description',
  boundaryNotDefined: 'Limite non encore définie',
  boundaryUnchanged: 'La limite du Site est inchangée',
  updateBoundaryBySelecting: 'Définir les limites du site en sélectionnant des entités dans les couches:',
  updateBoundaryByDrawing: 'Or use the controls below to draw the site boundary on the map:',
  updateBoundaryByDrawingOrEditing:
    'Ou utilisez les commandes ci-dessous pour dessiner les limites du site sur la carte:',
  invalidShapefileError: "Le fichier téléchargé n'a pas pu être traité. Veuillez télécharger un autre fichier.",
  shapefileWithNoLayersError:
    "Aucun polygone n'a été trouvé dans le shapefile téléchargé. Veuillez télécharger un autre fichier.",
  fileFormatError: 'Prière télécharger a fichier .zip',
  maxFileSizeError:
    'Le fichier téléchargé ne doit pas depasser {megabytes}MB. Veuillez télécharger un fichier plus petit.',
  boundaryOverlapsKBALayer:
    "WARNING: Les limites de votre proposition de KBA chevauchent celles d'une autre KBA existante. La KBA peut être proposée, mais assurez-vous d'avoir entrepris les consultations nécessaires pour tenter de résoudre la ou les zones de chevauchement.",
  uploadKBAShpFileHint: 'Télécharger un fichier shapefile zippé de moins de 5MB.',
  addLayer: 'Ajouter une Couche',
  layerNamePlaceholder: 'Saisir un nom à afficher dans la liste des couches',
  layerName: 'Nom de la Couche',
  firstAddLayer: 'Téléchargez d\’abord un fichier de formes ou ajoutez un calque...',
  selectFromLayers: 'Sélectionner parmi les calques',
  uploading: 'Téléchargement...',
  mapLayers: 'Couches de carte',
  uploadShapefile: 'Télécharger le fichier de formes',
  selectFromLayersInstructions:
    'Sélectionnez les fonctionnalités en cliquant sur la carte ou en utilisant le tableau. CTRL + cliquer/glisser vous permet de sélectionner rapidement plusieurs fonctionnalités!',
  featuresSelected: 'Fonctionnalités sélectionnées',
  selectingFeatures: 'Sélection des fonctionnalités pour {boundaryName}',
  useSelectedFeatures: 'Utiliser les fonctionnalités sélectionnées',
  layerSelectLabel: 'Couche à sélectionner',
  layerSelectPlaceholder: 'Sélectionnez la couche avec les fonctionnalités pour votre limite',
  featureTable: 'Tableau des fonctionnalités',
  showingSelectedFeatures: 'Affichage des fonctionnalités sélectionnées',
  showingFeaturesOnScreen: "Affichage des fonctionnalités à l'écran",
  replaceExistingBoundary: 'Remplacer la limite existante',
  zoomToLayer: 'Zoomer sur la couche',
  selectBasemap: 'Séléctionner la carte de base',
  increaseOpacity: "Augmenter l'opacité",
  decreaseOpacity: "Diminuer l'opacité",
  delete: 'Supprimer',
  addFeatureService: "Lien vers l'URL",
  layerUrl: 'URL',
  verifyUrl: "Vérifier l'URL",
  layerUrlPlaceholder: "Saisir l'URL du domaine d'application",
  selectedLayerOutOfRange: 'La couche sélectionnée est actuellement hors de la plage.',
  selectedLayerNotVisible: "La couche sélectionnée n'est pas visible. Activez l'affichage dans la liste des couches.",
  layerVerified: 'Couche vérifiée!',
  scaleField: 'Echelle: 1 : {scale, number}',
  latitudeAndLongitudeFields: 'Latitude: {latitude}, Longitude: {longitude}',
  zoomToEditAction: 'Zoomer et modifier',
  zoomInToEdit: "Zoom avant d'au moins 1 : {scaleCutoff, number} est recommandé pour modifier la limite actuelle.",
  editWithoutZooming: 'Modifier sans zoomer',
  siteBoundaryNotEditable: "La limite du site n'est pas modifiable",
  boundaryIsTooComplexAlertMessage:
    'La limite sélectionnée ne peut pas être modifiée à cette étape. Cliquez sur la limite pour obtenir des instructions supplémentaires sur son remplacement.',
  boundaryIsTooComplexPopupMessage:
    "La limite sélectionnée ne peut pas être modifiée à cette étape. Si des révisions sont nécessaires, une noulelle limite devra être créée localement et téléchargé. Pour ce faire, veuillez d'abord supprimer cette limite, puis suivez les étapes habituelles pour télécharger une limite nouvelle (corrigée).",
  mapView: 'Affichage de la carte',
  tableView: 'Affichage du tableau',
  showTable: 'Afficher le tableau:',
  filterByName: 'Filtrer par Nom:',
  filterByCountry: 'Filtrer par Pays:',
  enterKBAName: 'Saisir le nom national de la KBA',
  superseded: 'Remplacé',
  statuses: 'Statuts:',
  warningModalHeader: "Cette espèce n'est pas reconnue → Cette espèce n'est pas reconnue",
  warningModalExplanation:
    "Cette espèce n'est pas actuelllement reconnue - veuillez sélectionner une ou plusieurs des options non qualifiantes (y compris «Révision taxonomique ») avant de cliquer sur réévaluer, et si vous souhaitez réévaluer la version taxonomique actuelle, ajoutez-la comme une nouvelle espèce à partir de la fenêtre d'évaluation principale.",
  continue: 'Continuer',
  warningModalHeaderSpecies: "Cette espèce n'est pas reconnue",
  nonQualifyReasonWarning:
    "Veuillez sélectionner une ou plusieurs des options non qualifiantes ci-dessous avant de cliquer sur réévaluer ou d'annuler votre réévaluation.",
  assessmentParameter: "Paramètres d'évaluation",
  proposalPurposeHint:
    "Veuillez indiquer l'objet de votre proposition en sélectionnant l'une des options ci-dessous et assurez-vous de fournir des détails supplémentaires dans la zone de texte ouverte qui suit. Pour les évaluations et réévaluations, veuillez examiner les exigences définies dans le document « Processus de Proposition des Zones Clés pour la Biodiversité : Guide pour Proposer, Réviser, Nommer et Confirmer des sites » disponible ici lien vers Outils, et lors des réévaluations, veuillez revoir et réviser si nécessaire tous les aspects de la proposition (détails du site, limite de la ZCB, etc.). Si vous sélectionnez l'une des options de modification uniquement, vous ne procédez pas à une évaluation ou à une réévaluation, mais soumettez simplement des corrections de la limite ou des modifications mineures qui ne nécessitent pas de réévaluation, comme la correction de fautes d'orthographe. Vous devrez cliquer sur proposer une fois ces modifications effectuées. Ces modifications seront examinées par le RFP et le Secrétariat ZCB, et si elles sont approuvées, la date de l'évaluation ne sera pas mise à jour.",
  proposalDetailsHint: 'Fournissez tout autre détail concernant la nature de votre proposition',
  proposalPurposeLabel: "Indiquez l'objet de votre proposition",
  proposalDetailsLabel: 'Fournissez tout autre détail concernant la nature de votre proposition',
  proposalDetailsPlaceholder: "Fournissez d'autres détails sur votre proposition",
  proposalPurposePlaceholder: "Sélectionnez l'objet de votre proposition",
  editNow: 'Modifier Seulement',
  editOnlyStatus: 'Modifier Seulement',
  submitEdits: 'Proposer les Modifications',
  deleteEdits: 'Supprimer les Modifications',
  editOnlyMessage:
    "En cliquant sur « Continuer », votre évaluation sera en mode « Modifier Seulement ». Cette option permet de modifier certains champs des onglets « Détails du site » et « A propos » et ne constitue pas une réévaluation. Dans l'onglet « A propos », veuillez indiquer votre nom et la liste des champs que vous modifiez (ou résumer les modifications apportées si elles concernent plusieurs champs). Notez qu'aucun autre utilisateur ne peut modifier ou réévaluer le site tant que vous n'avez pas terminé ou annulé vos modifications. Vous pouvez inviter des collaborateurs à contribuer en utilisant l'option « Inviter des co-proposants ». Si vous décidez de ne pas poursuivre, vous pouvez annuler vos modifications à tout moment. Une fois vos modifications finalisées, soumettez-les pour la revue afin de terminer le processus.",
  reassessmentMessage:
    "En cliquant sur Évaluer la biodiversité, vous lancez une réévaluation et ce site ne peut être évalué par personne d'autre tant que vous n'avez pas terminé le processus (jusqu'au statut confirmé). Vous pouvez inviter d'autres personnes à participer à l'évaluation grâce à l'option « Inviter des co-proposants ». Si vous décidez de ne pas terminer la réévaluation, vous pouvez supprimer votre projet d'évaluation à tout moment.",
  submit: 'Proposer',
  approveEdits: 'Approuver les modifications',
  // contributorsAssessmentHint:'Veuillez indiquer les personnes ayant contribué à cette évaluation, en indiquant leur nom et, le cas échéant, leur institution. Veuillez ajouter ces contributeurs à la liste des contributeurs du site (Détails du site). Pour des raisons de confidentialité, n\'incluez pas d\'informations supplémentaires telles que vos coordonnées.',

  '/sites/map': 'Sites management map',
  apiKeysTitle: 'API Keys',
  browseShapeFile: 'Browse Shapefile',
  bulkImportData: 'Bulk Import Data (Optional)',
  bulkImportShapeFile: 'Bulk Import Shapefile (Optional)',
  cancelEcosystemReassessment: 'Cancel ecosystem reassessment?',
  confirmBulkReassessment: 'I confirm this Excel includes bulk reassessments',
  congregationTriggerPlaceholder: 'If this congregation no longer qualifies — please select all reason(s',
  contributors_assessment: 'Contributors to this assessment',
  contributorsAssessmentPlaceholder: 'Enter contributors to this assessment',
  criterionCTriggerPlaceholder: 'If this ecological integrity no longer qualifies — please select all reason(s',
  criterionETriggerPlaceholder: 'If this irreplaceability no longer qualifies — please select all reason(s',
  downloadTemplate: 'Download Template',
  filesUploadedSuccessfully: 'Files uploaded successfully',
  generateApiKey: 'Generate API Key',
  ibaStatus: 'IBA status',
  ignoreExistingHabitats: 'Ignore existing habitats',
  justificationNoChangeCongregationPlaceholder: 'Please provide justification if you are not providing updated assessment details -  e.g. if you are delisting a congregation or if you are inferring that the trigger element extent is unchanged based on some other evidence',
  justificationNoChangeCriterionCPlaceholder: 'Please provide justification if you are not providing updated assessment details -  e.g. if you are delisting an criterion C or if you are inferring that the trigger element extent is unchanged based on some other evidence',
  justificationNoChangeCriterionEPlaceholder: 'Please provide justification if you are not providing updated assessment details -  e.g. if you are delisting an criterion E or if you are inferring that the trigger element extent is unchanged based on some other evidence',
  kbaAssessment: 'KBA assessment',
  lastProposer: 'Last proposer',
  orDragAZipFileHere: 'or drag a ZIP file here (30MB max. size)',
  orDragAxlsxFileHere: 'or drag a XLSX file here (30MB max. size)',
  returnDiscardEcosystemChangesText: 'Are you sure you want to discard the reassessment for {ecosystemName}? All of your changes will be discarded and the former assessment of this ecosystem will be reinstated.',
  seasonId: 'Season ID',
  seasonPlaceholder: 'Select a season',
  seasonToolTip: 'Select season',
  selectLevelThreeHabitat: 'Select from level three options',
  speciesUploader: 'Upload supporting documentation species assessments',
  speciesUploaderHint: 'Please upload any documentation that supports species included in the identification of this KBA (word files, PDFs, excel files, spatial data etc.). Include the site code, year of assessment, and mention of the species in the names of any files uploaded. Note the total size of your files uploaded should not exceed 50MB. If you have many spatial files that you wish to provide please contact the KBA Secretariat. Once the KBA is confirmed this documentation will not be visible to WDKBA users.',
  triggerCongregationLabel: 'Reason(s) why congregation no longer qualifies',
  uploadSupportingDocumentation: 'Upload supporting documentation',
  uploadSupportingDocumentationHint: 'Please upload any documentation that supports this KBA proposal (word files, PDFs, excel files, spatial data etc.). Include the site code, year of assessment, and mention of the species in the names of any files uploaded. Note the total size of your files uploaded should not exceed 50MB.',
  yearMax: 'Year (max)',
  yearMaxPlaceholder: 'Last year of the dataset',
  yearMaxToolTip: 'Enter latest year of the data',
  yearMin: 'Year (min)',
  yearMinPlaceholder: 'Earliest year of the dataset',
  yearMinToolTip: 'Enter earliest year of the data',
  // sensitiveSpeciesWarningTitle: 'Veuillez noter :',
  sensitiveSpeciesWarningBody: 'Veuillez expliquer clairement quelles espèces ou quels groupes taxonomiques vous envisagez de réévaluer – il se peut que certaines des espèces qualifiantes de ce site aient été marquées comme sensibles et ne soient pas immédiatement visibles pour vous en tant que proposant individuel. Si votre(vos) groupe(s) taxonomique(s) d’intérêt inclut(des) ces espèces sensibles, le Secrétariat KBA vous contactera à ce sujet.',
  sensitiveSpeciesSubmitted: 'Votre demande de réévaluation de ce site a bien été reçue et sera traitée sous peu. Merci de votre patience.',
  sensitiveSpeciesAlreadySubmitted: 'Cette demande a déjà été soumise.',
  sensitiveSpeciesSubmitError: 'Échec de l\'envoi des données sur les espèces sensibles. Veuillez réessayer.',
  submitting: 'Envoi en cours...',
  failedToLoadSensitiveSites: 'Impossible de charger les sites sensibles. Veuillez réessayer.',
  sensitiveSiteApproved: 'Le site d\'espèces sensibles a été approuvé avec succès.',
  failedToApproveSensitiveSite: 'Impossible d\'approuver ce site. Veuillez réessayer.',
  sensitiveSiteRejected: 'Le site d\'espèces sensibles a été rejeté.',
  failedToRejectSensitiveSite: 'Impossible de rejeter ce site. Veuillez réessayer.',
  okay: 'D\'accord',
  // yearSpeciesDetailsHint: 'Most recent year for evidence of presence',
  sensitiveSpeciesWarningTitle: 'Avertissement sur les Espèces Sensibles',
  // sensitiveSpeciesWarningBody:
  //   'Ce site contient des espèces sensibles. Veuillez noter que les données sur les espèces sensibles ne seront pas publiées publiquement.',
  // okay: "D'accord",
  contributorsAssessmentHint:
    "Veuillez indiquer les personnes ayant contribué à cette évaluation, en indiquant leur nom et, le cas échéant, leur institution. Veuillez ajouter ces contributeurs à la liste des contributeurs du site (Détails du site). Pour des raisons de confidentialité, n'incluez pas d'informations supplémentaires telles que vos coordonnées.",
  //monitoring
  state: 'État',
  pressure: 'Pression',
  response: 'Réponse',
  guidanceandtools: 'Conseils et outils',
  selectStatePressureResponse: 'Sélectionnez l’état, la pression et/ou la réponse',
  monitoringEvaluation: 'Évaluation de la surveillance',
  addMonitoringEvaluation: 'Ajouter une Évaluation de la Surveillance',
  editMonitoringEvaluation: 'Modifier une Évaluation de la Surveillance',
  editMonitoringRevaluation: 'Modifier la réévaluation du suivi',
  reEvaluateMonitoring: 'Réévaluer la surveillance',
  viewMonitoringEvaluation: 'Voir une Évaluation de la Surveillance',
  monitoringAboutPageTitle: 'À propos de l’évaluation du suivi',
  aboutMonitoringEvaluation: "À propos de l'évaluation de la surveillance",
  monitoringSubHeading: 'Quel sera ce sous-titre ?',
  evaluationTypeQuestion: "Lequel de l'État, de la Pression et de la Réponse allez-vous évaluer ?",
  selectEvaluationType: "Sélectionnez le type d'évaluation",
  stateDataQuality: "Qualité des données d'État :",
  stateDataQualityInfo: "Fournir une indication de la qualité des données d'État",
  pressureDataQuality: 'Qualité des données de pression :',
  pressureDataQualityInfo: 'Fournir une indication de la qualité des données de pression',
  responseDataQuality: 'Qualité des données de réponse :',
  responseDataQualityInfo: 'Fournir une indication de la qualité des données de réponse',
  additionalSiteFeedback: 'Commentaires supplémentaires sur le site',
  monitoringObjective: "Décrire l'objectif de cette surveillance",
  monitoringReferences: 'Fournir toutes les références ou autres sources',
  monitoringMethods: 'Décrire les méthodes, outils ou équipements utilisés pour cette surveillance',
  uploadSupportingMaterial: 'Télécharger le matériel de support',
  otherRelevantDetails: 'Autres détails pertinents',
  selectAllThatApply: "Sélectionnez tout ce qui s'applique",
  stateDataInfo:
    "Sélectionnez l'option qui reflète le mieux la qualité des données ou des connaissances utilisées pour votre évaluation de l'état.",
  pressureDataInfo:
    "Sélectionnez l'option qui reflète le mieux la qualité des données ou des connaissances utilisées pour votre évaluation de la pression.",
  responseDataInfo:
    "Sélectionnez l'option qui reflète le mieux la qualité des données ou des connaissances utilisées pour votre évaluation de la réponse.",
  additionalFeedbackinfo:
    'Fournissez tout contexte ou toute information supplémentaire pertinente à cette évaluation de la surveillance.',
  monitoringReferencesinfo:
    'Fournissez tout contexte ou toute information supplémentaire pertinente à cette évaluation de la surveillance.',
  otherRelevantDetailsInfo:
    'Fournissez tout contexte ou toute information supplémentaire pertinent à cette évaluation de la surveillance.',

  monitoringAboutPageSubTitle: 'Quel sera ce sous-titre ?',
  monitoringAboutProposalHint:
    'Indiquez les critères que vous appliquez sur le site, même si le site ne les respecte pas tous.',
  evaluationTypeLabel: 'Lequel de l’État, de la Pression et de la Réponse allez-vous évaluer ?',
  stateDataQualityPlaceholder: 'Indiquez la qualité de vos données d’état',
  pressureDataQualityPlaceholder: 'Indiquez la qualité de vos données de pression',
  responseDataQualityPlaceholder: 'Indiquez la qualité de vos données de réponse',
  stateDataQualityLabel: 'Qualité des données d’état :',
  pressureDataQualityLabel: 'Qualité des données de pression :',
  responseDataQualityLabel: 'Qualité des données de réponse :',
  monitoringEvaluationDateLabel: 'Date de l’évaluation du suivi',
  monitoringEvaluationDatePlaceholder: 'Sélectionnez la date de l’évaluation du suivi',
  stateDataQualityHint:
    'Sélectionnez l’option qui reflète le mieux la qualité des données/connaissances informant votre évaluation de l’état.',
  pressureDataQualityHint:
    'Sélectionnez l’option qui reflète le mieux la qualité des données/connaissances informant votre évaluation de la pression.',
  responseDataQualityHint:
    'Sélectionnez l’option qui reflète le mieux la qualité des données/connaissances informant votre évaluation de la réponse.',
  additionalSiteFeedbackPlaceholder: 'Veuillez fournir tout commentaire supplémentaire.',
  additionalSiteFeedbackHint:
    'Ajoutez tout autre commentaire reflétant votre compréhension globale de ce qui se passe sur le site : éléments déclencheurs, pressions et efficacité des actions.',
  provideAnyReferencesSources: 'Fournir des références ou d’autres sources',
  provideAnyReferencesSourcesPlaceholder: 'Références et sources utilisées pour informer cette évaluation du suivi.',
  provideAnyReferencesSourcesHint:
    'Fournissez des détails ou des références utilisés pour informer cette évaluation du suivi',
  uploadRelevantFiles: 'Télécharger des fichiers pertinents',
  uploadRelevantFilesHint:
    'Veuillez télécharger tout document justificatif (fichiers Word, PDF, Excel, données spatiales, etc.) appuyant cette évaluation du suivi. Le nom des fichiers doit clairement indiquer à quelle partie de l’évaluation ils se rapportent (et/ou inclure un fichier readme s’il y en a beaucoup). La taille totale des fichiers téléchargés ne doit pas dépasser 50 Mo.',
  anyOtherDetailsRelevance: 'Tout autre détail pertinent',
  anyOtherDetailsRelevancePlaceholder:
    'Une description générale de votre approche de l’évaluation du suivi et/ou tout autre commentaire que vous jugez utile.',
  statePressureQualityOptions:
    'Sélectionnez lequel de l’État, de la Pression et de la Réponse vous évaluerez (essayez d’évaluer les trois) ; votre sélection influencera le niveau de détail disponible dans les onglets suivants]',

  generalMonitoringFeedback:
    "Une description générale de la façon dont vous avez abordé l'évaluation de la surveillance et/ou tout autre retour que vous jugez utile",
  // Response
  responseTitle: 'Évaluation de la réponse',
  protectedAreas:
    "La bande qui reflète le pourcentage du site couvert par des Aires Protégées (AP) a été présélectionnée en fonction de la valeur générée par un chevauchement entre la couche KBA et celle des AP dans la WDPA. Si vous estimez que le pourcentage actuel couvert par les aires protégées n'est pas reflété avec précision, veuillez entreprendre une évaluation parallèle « Modification seule » pour modifier la valeur de pourcentage de couverture d'AP fournie par l'utilisateur dans l'onglet Détails du site.",
  conservationMeasures:
    "La bande qui reflète le pourcentage du site couvert par d'Autres Mesures de Conservation Efficaces par Zone (AMCEZA) a été présélectionnée en fonction de la valeur générée par un chevauchement entre la couche KBA et celle des AMCEZA dans la WDPA. Si vous estimez que le pourcentage actuel couvert par les AMCEZA n'est pas reflété avec précision, veuillez entreprendre une évaluation parallèle « Modification seule » pour modifier la valeur de pourcentage de couverture d'AMCEZA fournie par l'utilisateur dans l'onglet Détails du site.",
  managementPlanning:
    "Sélectionnez l'option qui reflète le mieux l'étendue de la planification de la gestion sur ce site",
  managementPlanningTitle: 'Planification de la gestion',
  responseEvaluationTitle: 'Évaluation de la réponse (Mesures de conservation du site)',
  provideConservationDetails: 'Fournir des détails sur les mesures de conservation sur le site',
  conservationActionTest: "Sélectionnez l'option qui reflète le mieux les actions de conservation sur ce site",
  coverageByProtectedAreas: 'Couverture par les Aires Protégées',
  coverageByOecms: "Couverture par d'Autres Mesures de Conservation Efficaces par Zone (AMCEZA)",
  conservationActionsUnderwayAndNeeded: 'Actions de conservation en cours et nécessaires',
  conservationActionsUnderwayAndNeededInfo:
    "Énumérez les actions de conservation les plus nécessaires et pertinentes pour les éléments déclencheurs de la biodiversité sur ce site. Veuillez également indiquer celles qui sont en cours. Si des informations sur les actions de conservation ont été fournies dans le cadre d'évaluations de suivi ou d'évaluations et de réévaluations antérieures, elles seront répertoriées – veuillez examiner les actions de conservation précédemment documentées qui sont pertinentes pour les éléments déclencheurs de critères pour ce site (nécessaires et/ou en cours). Mettez à jour cette liste : 1) en sélectionnant nécessaire et/ou en cours, 2) en ajoutant d'autres actions qui n'ont pas été documentées précédemment, ou 3) en supprimant celles qui ne sont plus pertinentes pour les éléments déclencheurs.",
  provideMonitoringDetails:
    'Répondez aux questions suivantes qui se rapportent à la planification de la gestion et aux actions de conservation ayant lieu sur le site, et fournissez des détails sur les mesures de conservation en cours et/ou nécessaires sur le site.',
  selectManagementPlanning: "Indiquez l'étendue de la planification de la gestion sur le site",
  // managementPlanningTitle: 'Planification de la gestion',
  selectConservationAction: "Indiquez l'étendue des actions de conservation sur le site",
  conservationActionsTitle: 'Actions de conservation',
  conservationActionsUnderway: 'Actions de conservation en cours',
  conservationActionsNeeded: 'Actions de conservation nécessaires sur le site',
  bulkAction: 'Action groupée',
  selectTiming: 'Sélectionner le moment',
  deleteConservationActionSuccess: 'Action de conservation supprimée avec succès',
  deleteConservationActionError: "Erreur lors de la suppression de l'action de conservation. Veuillez rééssayer",
  actionsLevel1: 'Actions - Niveau 1',
  actionsLevel2: 'Actions - Niveau 2',
  actionsLevel3: 'Actions - Niveau 3',
  selectAction: "Sélectionner l'action",
  monitoringForDeletingDraft:
    'Êtes-vous sûr de vouloir supprimer définitivement\n' + 'ce brouillon ? Cette action est irréversible.',
  editmonitoringForDeletingBody:
    'Êtes-vous sûr de vouloir supprimer définitivement\n' + 'ce suivi de la liste ? Cette action est irréversible.',
  assessments: 'Évaluations',
  biodiversityEvaluations: 'Évaluations de la biodiversité',
  allBiodiversityEvaluations: 'Toutes les évaluations {assessmentsNumber}',
  noBiodiversityEvaluations: 'Toutes les évaluations (0)',
  furtherDetails: "Fournissez des détails supplémentaires expliquant vos sélections d'actions de conservation ci-dessus",
  furtherDetailsPlaceholder: 'Veuillez fournir des détails supplémentaires',

  // state
  stateTitle: 'Évaluation de l’état',
  toolTipstateTitle:
    'Les espèces et les écosystèmes d’importance sur ce site sont listés ci-dessous et peuvent être sélectionnés pour l’évaluation. Vous pouvez sélectionner tous les déclencheurs ou cocher une sélection d’éléments déclencheurs. Ces déclencheurs constitueront la base de votre évaluation de l’état et les détails devront être complétés pour tous ceux que vous sélectionnez. Vous pouvez ajuster cette sélection au fur et à mesure de votre progression.',
  stateSubHeading: 'Sélectionnez les éléments de biodiversité que vous souhaitez suivre pour l’état',
  selectBiodiversity: 'Sélectionner la biodiversité',
  selectBiodiversityInfo:
    'Sélectionnez les éléments de biodiversité qui constitueront la base de votre évaluation de l’état',
  toolTipselectBiodiversity:
    'Sélectionnez les espèces déclencheuses et/ou les types d’écosystèmes de cette KBA qui reflètent l’état du site et que vous suivrez (ou sélectionnez « Tous »)',
  createStateEvaluation: 'Créer une évaluation de l’état',
  selectState: 'Tout sélectionner',
  stateShowing: 'Affichage',
  add: 'Ajouter',
  stateBiodiversityTitle: 'Éléments de biodiversité à évaluer pour l’état',
  stateBiodiversitysub: 'Sélectionnez les éléments de biodiversité pour ajouter plus de détails d’évaluation',
  triggers: 'Déclencheurs',
  triggersSub: 'Sélectionnez les déclencheurs pour ajouter les détails de l’évaluation de l’état',
  addMoreTrigger: 'Ajouter d’autres déclencheurs à l’évaluation de l’état',
  benchmarkDetails: 'Détails de référence',
  benchmarksubhead: 'Détails de référence pour l’élément déclencheur sélectionné',
  benchmarktooltip:
    'Indiquez la nature de l’évaluation de l’état pour ce déclencheur en sélectionnant l’une des options ci-dessous. Si vous pouvez fournir une estimation actuelle pour cet élément déclencheur, veuillez sélectionner la première option. Si vous ne disposez pas de données permettant une estimation mise à jour, vous pouvez indiquer une catégorie de changement.',
  biodiversitytriggerElement: 'Élément déclencheur de biodiversité',
  bioTaxonomicGroup: 'Groupe taxonomique',
  bioNumberEvaluation: 'Nombre d’évaluations de suivi',
  bioEvaluation: 'Sélectionner le nombre d’évaluations de suivi',
  bioBaselineYear: 'Année de référence',
  bioMonitoringPerameter: 'Paramètre de suivi',
  bioBenchmarkValue: 'Valeur de référence',
  bioMonitoringPerameterToolTip:
    'Si vous n’utilisez pas le paramètre d’évaluation initial de l’élément déclencheur, définissez le paramètre que vous avez choisi d’appliquer (par ex. nombre de nids, terriers, poussins éclos, etc.). Idéalement, le même paramètre devrait être utilisé lors des évaluations ultérieures.',
  bioBenchmarkValueToolTip:
    'Si vous n’utilisez pas l’estimation et le paramètre d’évaluation utilisés lorsque cet élément de biodiversité a été identifié pour la première fois comme déclencheur pour ce site, fournissez ici une estimation mise à jour et définissez le paramètre utilisé ci-dessous. Notez que cette estimation doit refléter l’abondance (espèce) / l’étendue (écosystème) pour l’année de référence.',
  bioSubTitle: 'Détails qui renseignent sur l’état de cet élément déclencheur sur le site',
  natureOfTheStateEvaluation: 'Définir la nature de l’évaluation de l’état pour ce déclencheur',
  toolTipbenchmarkfield:
    'Indiquez la nature de l’évaluation de l’état pour ce déclencheur en sélectionnant l’une des options ci-dessous. Vous pouvez soit 1) fournir une estimation actuelle pour cet élément déclencheur (première option), soit 2) indiquer la catégorie de changement si vous n’êtes pas en mesure de fournir une estimation mise à jour. Idéalement, cette catégorie de changement sera étayée par d’autres facteurs tels que, par exemple, une modification de l’étendue de l’habitat disponible (lorsque le déclencheur est connu pour être influencé par la disponibilité d’un habitat approprié), ou une évaluation basée sur un échantillon représentatif de données provenant du site. Pour les déclencheurs d’écosystèmes, veuillez également fournir une évaluation de l’état de conservation basée sur les catégories disponibles dans le menu déroulant. Les questions suivantes se rapporteront spécifiquement aux options sélectionnées.',
  changeGenuine: 'Le changement est-il réel',
  toolTip2:
    'Désélectionnez si l’évaluation de l’état fournie pour ce déclencheur ne reflète pas un changement réel de sa population / étendue / condition, mais résulte d’un autre facteur, par exemple une amélioration de la précision de l’estimation grâce à de meilleures techniques d’inventaire et d’analyse. Dans de telles circonstances, et lorsque vous fournissez une estimation mise à jour, si vous pouvez également ajuster la référence en conséquence, un changement réel est approprié. Vous pouvez fournir plus de détails sur les évaluations qui ne reflètent pas un changement réel dans « Tout autre détail pertinent » dans l’onglet « À propos ».',
  updateEstimate: 'Fournir une estimation mise à jour',
  benchmarkValuefield3: 'Fournir une estimation mise à jour de la valeur de référence',
  tooltip3: 'Fournir une estimation mise à jour basée sur la référence et le paramètre indiqués ci-dessus',
  benchmarkfield4: 'Fournir des détails supplémentaires pour justifier votre sélection',
  stateCategoryBestDescribes: 'Indiquer la catégorie d’état qui décrit le mieux le pourcentage restant',
  toolTipbenchmarkfield5:
    'Indiquez ci-dessous la catégorie d’état qui décrit le mieux le pourcentage (de la population de l’espèce ou de l’étendue de l’écosystème) restant par rapport à la référence',
  stateCategoryEcosystem:
    'Indiquer la catégorie d’état qui décrit le mieux la condition de cet écosystème déclencheur par rapport à la référence',
  toolTipbenchmarkfield6:
    'Cette question concerne spécifiquement les écosystèmes et la manière dont leur condition a évolué par rapport à la référence, et le résultat peut différer de l’étendue indiquée ci-dessus. Veuillez fournir ci-dessous des détails supplémentaires pertinents sur la manière dont la condition de l’écosystème a été mesurée et comparée.',
  categoryInferring: 'Comment cette catégorie inférant l’état a-t-elle été choisie ?',
  toolTip7:
    'Fournissez plus de détails sur les éléments de preuve qui ont influencé votre (vos) sélection(s) de catégorie(s) ci-dessus, par exemple d’autres observations indirectes pouvant être basées sur un suivi systématique dans la région / les zones environnantes ou ailleurs, ou des informations sur l’évolution d’une ou plusieurs menaces connues pour affecter le déclencheur au niveau de la KBA.',
  furtherDetailsJustify: 'Fournir des détails supplémentaires pour justifier votre sélection',
  toolTip8:
    'Fournissez tout autre détail pertinent concernant votre (vos) sélection(s) de catégorie(s) ci-dessus, par exemple pour la condition des écosystèmes, précisez comment la condition a été mesurée et comparée',
  benchmarkCondition: 'Condition de référence',
  modalTitle: 'Évaluation de l’état de l’espèce',
  backToSelection: 'Retour à la sélection',
  // species: 'Espèces',
  ecosystem: 'Écosystème',
  creating: 'Création...',
  noReassessmentHistory: "Il n'y a pas d'historique de réévaluation",
  confirmationIncomplete:
    'Cette évaluation comprend uniquement {sections}. Êtes-vous sûr de vouloir soumettre cette évaluation sans avoir complété les trois volets (état, pression et réponse) ?',
  confirmationFinal:
    'Êtes-vous sûr de vouloir soumettre cette évaluation ? Une fois soumise, elle ne pourra plus être modifiée.',
  validationMonitoring:
    'Il manque des informations dans votre évaluation de suivi ; veuillez vérifier les détails fournis et compléter les informations manquantes.(indiquées par un encadré rouge et un texte d’avertissement rouge)',
  pressureTriggerValidation: 'Veuillez compléter au moins un déclencheur',
  stateEvaluationValidation: 'Veuillez compléter au moins une évaluation',
  viewStateEvaluation: "Ouvrir l’évaluation",
  addMoreSpecies: 'Agregar especies',
  addMoreEcosystems: 'Agregar ecosistemas',
  stateEvaluationHint: 'Indiquez la nature de l’évaluation de l’état pour ce déclencheur en sélectionnant l’une des options ci-dessous. Si vous pouvez fournir une estimation actuelle pour cet élément déclencheur, veuillez sélectionner la première option. Si vous ne disposez pas de données appuyant une estimation mise à jour, vous pouvez indiquer une catégorie de changement.',
  managementPlanningInfo: 'Sélectionnez l’option qui reflète le mieux l’étendue de la planification de la gestion sur ce site.',
  monitoringSites: 'Evaluación de monitoreo',


  //pressure tab
  pressureTitle: "Évaluation de la pression",
  pressureSubHeading: "Lister les pressions affectant la biodiversité à ce site",
  selectPressures: "Sélectionner les pressions",
  selectPressuresInfo: "Sélectionner les pressions qui formeront la base de votre évaluation de pression",
  reviewPressureSelector: "Vérifier les pressions et leurs durées",
  reviewPressureSubtitle: "Sélectionner les déclencheurs pour ajouter les détails de l’évaluation d’état",
  pressureInfoTooltip: "Fournir des détails de surveillance concernant le site",
  threatTitle:"Les menaces ont un impact sur les détails de l'élément déclencheur",
  threatSubTitle:"Comment les éléments déclencheurs sont-ils affectés par les menaces ?",
  threaInfoToolTip:"Indiquez pour chaque menace les éléments déclencheurs affectés et, si possible, précisez la portée et la gravité de la menace sur chaque élément déclencheur impacté.",
  selectTriggerSpceies:"Sélectionnez les espèces déclencheurs",
  addDetailsEffect:"Ajoutez des détails sur l'effet",
  selected:'choisie',
  // expand:"Développer",
  close:"Fermer",
  scopeOfThreat:"Portée de la menace",
  severityOfThreat:"Gravité de la menace",
  threatTiming:"Durée de la menace",
  // selectTriggerSpeciesSubtitle:"Sélectionnez les éléments déclencheurs à inclure, puis cliquez sur 'Ajouter à l’évaluation'",
  selectTriggerSpeciesInfo:"Indiquez pour chaque menace les éléments déclencheurs affectés et, si possible, précisez la portée et la gravité de la menace sur chaque élément déclencheur impacté.",
  apply:"Appliquer",
  displaying:"Affichage",
  addDetails:"Ajouter plus de détails",
  nextTriggersAffected:"Suivant > déclencheurs affectés",
  selectedPressureTitle:"Pressions sélectionnées",
  pressureTriggerTitle:"Pressions affectant les éléments déclencheurs de ce site",
  pressureTriggerSubTitle:"Une fois ajoutés à votre évaluation, vous pouvez ajouter plus de détails",
  selectAll:"Tout sélectionner",
  addTriggersToEvaluationBtn:"Ajouter à l'évaluation",
  addEcosystemTriggersToEvaluationBtn:"Ajouter à l'évaluation",
  noRecordsFound:"Aucun enregistrement trouvé",
  selectTriggerEcosystemInfo:"Indiquez pour chaque menace les éléments déclencheurs affectés et, si possible, précisez la portée et la gravité de la menace sur chaque élément déclencheur impacté.",
  threatImpactTriggerTitle:"Impact des menaces sur les détails des éléments déclencheurs",
  threatImpactTriggerSubTitle:"Comment les éléments déclencheurs sont-ils affectés par les menaces ?",
  addMoreTriggerBtnText: "Ajouter {name}",
  threatTriggerSpecieSubTitle:"Sélectionnez les éléments déclencheurs à inclure, puis cliquez sur 'Ajouter à l’évaluation'",
  threatTriggerSpecieInfoTooltip:"Indiquez pour chaque menace les éléments déclencheurs affectés et, si possible, précisez la portée et la gravité de la menace sur chaque élément déclencheur impacté.",
  paste: "Coller",
  copy: "Copier",
  onlyForSelectedSpeciesTitle: "Les sélections suivantes ne seront appliquées qu'à l'espèce sélectionnée",
  onlyForSelectedTaxonomicTitle: "Les sélections suivantes seront appliquées à TOUTES les espèces de cette classe taxonomique",
  onlyForSelectedTaxonomicInfo: "Si toutes les espèces de cette classe taxonomique sont affectées de manière similaire (portée, gravité et durée) par cette menace, vous pouvez assigner ici les catégories de portée et de gravité et elles seront copiées à toutes les espèces de la classe",
  ScopeOfThreatTitle: "Portée de la menace",
  SeverityOfThreatTitle: "Gravité de la menace",
  TimingOfThreatTitle: "Durée de la menace",
  pressureEvaluationHint:'Dressez la liste de toutes les pressions (menaces) présentes sur le site qui sont considérées comme affectant les critères de déclenchement des éléments de biodiversité, et sélectionnez leur chronologie (actuelle, passée, future, etc.).',
  pressureValidation: "Veuillez compléter toutes les informations manquantes concernant la pression/menace avant de soumettre l'évaluation.",
  taxonDeleteModalTitle: "Confirmation de suppression",
  taxonDeleteModalMessage: "Voulez-vous supprimer le cours ?",
  speciesDeleteModalMessage: "Voulez-vous supprimer des espèces ?",
  ecosystemDeleteModalMessage: "Voulez-vous supprimer l'écosystème ?",
  bulkDeleteModalTitle: "Confirmation de suppression groupée",
  bulkSpeciesDeleteModalMessage: "Souhaitez-vous supprimer les espèces sélectionnées ?",
  bulkEcosystemDeleteModalMessage: "Souhaitez-vous supprimer l'écosystème sélectionné ?",
  bulkDeleteToasterConfirmationMessage: "Suppression en masse effectuée avec succès.",
  bulkDeleteToasterFailureMessage: "Impossible de supprimer les éléments sélectionnés.",
  pasteSuccessMessage: "Les éléments sélectionnés ont été collés avec succès.",
  pasteFailureMessage: "Impossible de supprimer les éléments sélectionnés.",
  beforeNotSelectBulkItemMessage: "Veuillez sélectionner les éléments avant de les supprimer.",
  beforeNotSelectCopyPasteItemMessage: "Veuillez sélectionner Copier avant de coller.",
  backToPressureBtnText: "Retour aux Pressions",
  triggerSpeciesNoSelectMessage: "Veuillez sélectionner au moins un article.",
  triggerEcosystemNoSelectMessage: "Veuillez sélectionner au moins un article.",
  addTriggerToThisEvaluationBtn: "Ajoutez des déclencheurs à cette évaluation",
  noTriggerSelectedText: "Aucun déclencheur sélectionné, premier",
monitorYear: 'Année de suivi',
numberTriggers: 'Déclencheurs suivis',
monitoringStatus: 'Statut de l’évaluation',
stateEvaluation: 'État terminé',
pressureEvaluation: 'Pression terminée',
responseEvaluation: 'Réponse terminée',
stateBest: 'Meilleur résultat de l’état',
stateWorst: 'Pire résultat de l’état',
stateMedian: 'Résultat médian de l’état',
pressureBest: 'Meilleur résultat des menaces',
pressureWorst: 'Pire résultat des menaces',
pressureMedian: 'Résultat médian des menaces',
pressureTotal: 'Total des menaces documentées',
coveragePa: 'Couverture par les aires protégées',
coverageOecm: 'Couverture par les OECM',
coveragePaOecm: 'Couverture par les aires protégées et les OECM',
// managementPlanning: 'Planification de la gestion',
conservationAction: 'Action de conservation',
actionsNeededUnderwayCount: 'Actions nécessaires et en cours',
actionsNeededCount: 'Actions nécessaires',
actionsUnderway: 'Actions en cours',

allSpeciesAdded: 'Toutes les espèces ont été ajoutées à l’évaluation de l’état',
allEcosystemsAdded: 'Tous les écosystèmes ont été ajoutés à l’évaluation de l’état',
// noRecordsFound: 'Aucun enregistrement trouvé',
addSpeciesBeforeEcosystems: 'Ajoutez le/la {type} sélectionné(e) avant d’ajouter {type2}.',
revertSubmission: 'Annuler la soumission',
monitoringEvaluationRevertConfirmation: 'Êtes-vous sûr de vouloir annuler cette évaluation de suivi ?',
enterParameter: 'Saisir le paramètre',
enterDetails: 'Saisir les détails',
removeMonitoring: 'Supprimer le suivi',
removeSpeciesModalText: 'Êtes-vous sûr de vouloir supprimer {name} de la liste ? Cette action est irréversible.',
removeEcosystemModalText: 'Êtes-vous sûr de vouloir supprimer {name} de la liste ? Cette action est irréversible.',
onlyForSelectedEcosystemTitle: "Les sélections suivantes ne seront appliquées qu'à cet écosystème sélectionné.",
evaluate: "Évaluer",
Removestate: 'Supprimer les éléments de biodiversité',
isPreviouslyStatedMonitoringParameter: 'Le paramètre de suivi indiqué précédemment est-il correct ?',
isPreviouslyStatedMonitoringParameterTooltip: 'Souhaitez-vous utiliser le paramètre de suivi existant tel qu’indiqué ci-dessus ?',
justifyPerameter: 'Justifier le paramètre',
justifyPerameterTooltip: 'Veuillez fournir une justification expliquant pourquoi une nouvelle valeur de référence est nécessaire. Par exemple, la valeur est-elle différente parce que la limite du site a été modifiée ? Ou existe-t-il une meilleure manière de mesurer le changement d’abondance de cette espèce au fil du temps ?',
benchmarkPerameterTool: 'Fournissez une estimation pour la nouvelle valeur de référence que vous avez sélectionnée pour cette espèce. Veuillez vous assurer qu’elle reflète l’année de référence indiquée ci-dessus. Votre valeur mise à jour sera mesurée par rapport à cette nouvelle valeur de référence.',
otherParameter: 'Autre',
enterparameter: 'Saisir le paramètre',
}
export default frenchFR
